import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { ListasService } from '../../../services/listas.service';
import { ListaDTO } from '../../util/modal-datos/dtos/lista-DTO';
import { ListaValorConstants } from '../../../constants/lista-valor.constants';
import { ListaValorResponseDto } from '../../../dto/tramites/lista_valor.dto';
import { ArchivoItemDto } from '../../util/archivos-tramite/dto/ArchivoItemDto';
import { PaisDto } from '../../../dto/expediente/pais.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import {
  PersonaDto,
  PersonaJuridicaDTO,
  PersonaNaturalDTO,
} from '../../../dto/tramites/persona.dto';
import { ListaValorService } from '../sic/proteccion-al-consumidor/services/lista-valor.service';
import { PersonaConsultadaDTO } from '../../../dto/tramites/sic/persona-consultada-dto';
import { PersonaLoginDTO } from '../../../dto/util/persona.dto';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento.dto';
import { TableColumn } from '../../../dto/util/table-column';
import { TableAction } from '../../../dto/util/table-action';
import { TramiteSuperintendeciaMercantilesService } from '../../../services/tramite-superintendecia-mercantiles.service';
import { TramiteSuperintendeciaMercantilDto } from '../../../dto/tramites/tramite-superintendecia-mercantiles.dto';
import { Router } from '@angular/router';
import { TramiteService } from '../../../services/tramite.service';
import { TramiteDTO } from '../models/tramiteDTO';
import { Location } from '@angular/common';
import { firstValueFrom, combineLatest } from 'rxjs';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { AnexoPrecargaResponseDto } from '../../../dto/anexo/anexo-tramite.dto';
import { DireccionPersonaDto } from '../../../dto/tramites/direccion-persona.dto';
import { TranslateService } from '@ngx-translate/core';
import { CargueArchivosTramiteService } from '../../util/archivos-tramite/services/cargue-archivos-tramite.service';
import { TipoAnexoTipoTramiteDto } from '../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { TextTransformService } from '../../util/text-transform/text-transform.service';
import { DatosAdicionalesService } from '../../util/modal-datos/services/datos-adicionales.service';
import { DemandadoAuxDto } from "../../../dto/tramites/demandado-aux.dto";
import { ConfigurarCuentasService } from '../../configuracion-cuenta/services/configurar-cuentas.service';
import { LanguageService } from '../../../services/util/language.service';
import { FormComponent } from '../../util/form/form.component';

@Component({
  selector: 'app-asuntos-mercantiles',
  templateUrl: './asuntos-mercantiles.component.html',
  styleUrl: './asuntos-mercantiles.component.scss',
})
export class AsuntosMercantilesComponent implements OnInit {

  // Formularios
  idiomaActual: string = 'es';
  asunto: FormField[] = [];
  tipoPersonaDemandante: FormField[] = [];
  demandantePN: FormField[] = [];
  demandantePJ: FormField[] = [];
  apoderado: FormField[] = [];
  tipoPersonaDemandanda: FormField[] = [];
  demandadaPN: FormField[] = [];
  demandadaPJ: FormField[] = [];
  paises: PaisDto[] = [];

  // Boolean
  formAsuntoValido: boolean = false;
  mostrarTipoPersonaDemandante: boolean = false;
  formTipoPersonaValidoDemandante: boolean = false;
  mostrarFomularioNaturalDemandante: boolean = false;
  formDatosDemandantePnValido: boolean = false;
  mostrarFomularioJuridicoDemandante: boolean = false;
  formDatosDemandantePjValido: boolean = false;

  mostrarApoderado: boolean = false;
  formDatosApoderadoValido: boolean = false;

  isEditarDemandante: boolean = false;
  isEditarApoderado: boolean = false;
  isEditarDemandado: boolean = false;
  indiceArrayDemandante: number = 0;
  indiceArrayDemandando: number = 0;
  indiceArrayApoderado: number = 0;

  // DEMANDADA
  mostrarTipoPersonaDemandada: boolean = false;
  formTipoPersonaValidoDemandada: boolean = false;
  mostrarFomularioNaturalDemandada: boolean = false;
  mostrarFomularioJuridicoDemandada: boolean = false;
  formDatosDemandadaPnValido: boolean = false;
  formDatosDemandadaPjValido: boolean = false;
  // Archivos
  mostrarArchivos: boolean = true;
  enviarDocumentos = false;
  archivosCargados: ArchivoItemDto[] = [];

  // Tipo persona seleccionado
  idTipoPersonaSeleccionadoDemandante: unknown;
  idTipoPersonaSeleccionadoDemandada: unknown;

  // Tramite
  tipoTramite: number = Constants.ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES;
  idTramiteAsuntosMercantiles: number = 0;
  idTramite!: number | null;

  // Listas
  generos: ListaDTO[] = [];
  listaTipoSociedad: ListaValorResponseDto[] = [];
  listaTipoAsunto: ListaValorResponseDto[] = [];
  entidadId = Constants.ID_ENTIDAD_SUPER_SOCIEDADES;
  listaTiposDocumento: TipoDocumentoDto[] = [];

  demandantes: PersonaDto[] = [];
  apoderados: PersonaDto[] = [];
  demandados: PersonaDto[] = [];

  // Formularios
  formTipoAsunto!: FormGroup;
  formTipoPersonaDemandante!: FormGroup;
  formDemandanteNatural!: FormGroup;
  formDemandanteJuridico!: FormGroup;
  formApoderado!: FormGroup;
  formTipoPersonaDemandada!: FormGroup;
  formDemandadaNatural!: FormGroup;
  formDemandadaJuridico!: FormGroup;

  dataUsuario!: PersonaLoginDTO;

  // Tablas
  mostrarTablaDemandantes: boolean = false;
  mostrarTablaDemandados: boolean = false;
  mostrarTablaApoderados: boolean = false;
  columnsDemandantes: TableColumn[] = [];
  columnsDemandados: TableColumn[] = [];
  columnsApoderados: TableColumn[] = [];
  actions: TableAction[] = [];
  dataTableDemandantes: PersonaDto[] = [];
  dataTableDemandados: PersonaDto[] = [];
  dataTableApoderado: PersonaDto[] = [];

  // precarga
  onDemandantes: boolean = true;
  onApoderados: boolean = true;
  onDemandados: boolean = true;

  idAsunto: number | null = null;
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  enviarEntidad: boolean = false;

  archivosPreCargados: AnexoPrecargaResponseDto[] = [];
  submitFinalizar: boolean = false;

  // Multilenguaje
  asuntosText: any = {};
  comunText: any = {};
  alertaText: any = {};

  // anexos para tramite
  anexosTramiteObligatorios: TipoAnexoTipoTramiteDto[] = [];

  auxIdCountryDemandante: number[] = [];
  auxIdCountryDemandanteRl: number[] = [];
  auxIdCountryApoderado: number[] = [];
  auxIdCountryDemandado: number[] = [];

  // Existe persona
  existePersonaDemandante: boolean = false;
  existePersonaDemandado: boolean = false;
  existePersonaApoderada: boolean = false;

  confirmacionEnvio: boolean = false;
  enviarCorreoDemandado: boolean = false;
  demandadoAux: DemandadoAuxDto = {};
  pesoTotalArchivosMB: string = '0.00';
  seleccionAceptoRechazoEnvio = false;
  entidad = '';
  // String
  nombreTramite = '';

  @ViewChildren(FormComponent) personaComponentes!: QueryList<FormComponent>;

  constructor(
    private readonly listaServices: ListasService,
    private readonly servicePersona: ListaValorService,
    private readonly fb: FormBuilder,
    private readonly alertaModalService: AlertaModalService,
    private readonly serviceMercantiles: TramiteSuperintendeciaMercantilesService,
    private readonly router: Router,
    private readonly tramiteService: TramiteService,
    private readonly location: Location,
    private readonly utilService: UtilService,
    private readonly translate: TranslateService,
    private readonly cargueArchivosTramiteService: CargueArchivosTramiteService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly _cuentaService: ConfigurarCuentasService,
    private languageService: LanguageService,
    private readonly cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    this.nombreTramite = JSON.parse(
      sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO)!
    );
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
    ]).subscribe(([tramitesText, comunLabelText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.asuntosText[key] = tramitesText[key];
      }

      this.tramiteService.obtenerNombreEntidadPorId(1).subscribe({
        next: (data) => {
          this.entidad = data.entidad;
        },
        error: (err) => console.error('Error al obtener entidad', err),
      });

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }

      // Llamar a buildForms una sola vez
      this.inicializarFormularioAsunto();
      this.inicializarFormularioDemandantes();
      this.inicializarFormularioApoderado();
      this.inicializarFormulariosDemandados();
      this.getTypeDocuments();
      this.getListaGeneros();
      this.getListaSociedades();
      this.getCountries();
      this.getListaAsuntos();
      this.iniciarColumnasDemandantes();
      this.iniciarColumnasApoderados();
      this.iniciarColumnasDemandados();
      this.getAnexosTramite(this.tipoTramite);
    });

    this.formTipoAsunto = this.fb.group({
      asunto: [''],
    });

    this.formTipoPersonaDemandante = this.fb.group({
      tipoPersonaDemandante: [''],
    });

    this.formDemandanteNatural = this.fb.group({
      tipoPersonaDemandante: [''],
      primerNombre: [''],
      segundoNombre: [''],
      primerApellido: [''],
      segundoApellido: [''],
      genero: [''],
      typeOfDocument: [''],
      numberOfDocument: [''],
      fechaNacimiento: [''],
      nacionalidadPerson: [''],
      nacionalidadDouble: [''],
      country: [''],
      departament: [''],
      municipality: [''],
      direccionPersona: [''],
      addressNotificationJudicial: [''],
      telefono: [''],
      fax: [''],
      apartadoAereo: [''],
      email: [''],
      paginaWeb: [''],
    });

    this.formDemandanteJuridico = this.fb.group({
      tipoPersonaDemandante: [''],
      razonSocial: [''],
      tipoSociedad: [''],
      numberOfDocument: [''],
      country: [''],
      departament: [''],
      municipality: [''],
      addressNotificationJudicial: [''],
      telefono: [''],
      fax: [''],
      apartadoAereo: [''],
      email: [''],
      paginaWeb: [''],
      primerNombreRl: [''],
      segundoNombreRl: [''],
      primerApellidoRl: [''],
      segundoApellidoRl: [''],
      genero: [''],
      fechaNacimiento: [''],
      typeOfDocumentRl: [''],
      numberOfDocumentRl: [''],
      emailRl: [''],
      nacionalidadPerson: [''],
      nacionalidadDouble: [''],
      countryRl: [''],
      departamentRl: [''],
      municipalityRl: [''],
      direccionPersona: [''],
      addressNotificationJudicialRl: [''],
      phoneRl: [''],
      faxRl: [''],
      apartadoAereoRl: [''],
      emailNotificacionRl: [''],
    });

    this.formApoderado = this.fb.group({
      tipoPersona: [''],
      primerNombre: [''],
      segundoNombre: [''],
      primerApellido: [''],
      segundoApellido: [''],
      typeOfDocument: [''],
      numberOfDocument: [''],
      tarjetaProfesional: [''],
      email: [''],
      telefono: [''],
      country: [''],
      departament: [''],
      municipality: [''],
      addressNotificationJudicial: [''],
    });

    this.formTipoPersonaDemandada = this.fb.group({
      tipoPersonaDemandada: [''],
    });

    this.formDemandadaNatural = this.fb.group({
      tipoPersonaDemandada: [''],
      email: [''],
      primerNombre: [''],
      segundoNombre: [''],
      primerApellido: [''],
      segundoApellido: [''],
      typeOfDocument: [''],
      numberOfDocument: [''],
      country: [''],
      departament: [''],
      municipality: [''],
      addressNotificationJudicial: [''],
    });

    this.formDemandadaJuridico = this.fb.group({
      tipoPersonaDemandada: [''],
      email: [''],
      razonSocial: [''],
      tipoSociedad: [''],
      numberOfDocument: [''],
      country: [''],
      departament: [''],
      municipality: [''],
      addressNotificationJudicial: [''],
    });
    this.getDataUser(this.dataUsuario.idUsuario!);

    // window.addEventListener('beforeunload', this.unloadNotification);

    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        this.dataUsuario.idUsuario!,
        Constants.ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.idTramite = resp.Id;
              this.idTramiteAsuntosMercantiles = resp.Id;
              this.mostrarArchivos = false;
              this.consultarTramitePorID(resp.Id, false);
              // this.dataUsuario = undefined;
            },
            () => {
              this.idTramite = null;
              // this.dataUsuario = JSON.parse(
              //   sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
              // );
            },
            true
          );
        } else {
          this.idTramite = null;
          // this.dataUsuario = JSON.parse(
          //   sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
          // );
        }
      });

    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: '',
      descripcionPantalla: '',
      pasos: [],
      // Evento en el botón volver
      change: async op =>
        await this.guardarAntesDeSalir(
          this.alertaModalService,
          this.location,
          op
        ),
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
  }

  // Función para mostrar alerta antes de salir de la pantalla
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.callServiceCrearTramite();
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  // Se consume el servicio de consultar el detalle del trámite según el ID
  async consultarTramitePorID(id: number, isContinuar: boolean) {
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          this.mostrarTablaDemandantes = true;
          this.mostrarTablaDemandados = true;
          this.mostrarTablaApoderados = true;
          this.idTramiteAsuntosMercantiles = id;
          this.mostrarArchivos = true;
          if (resp.anexos) {
            this.archivosPreCargados = resp.anexos;
          }
          this.idAsunto = resp.idAsunto;
          if (resp.idAsunto) {
            this.asunto = this.asunto.map((field: FormField) => {
              if (field.name == 'asunto') {
                field.value = resp.idAsunto;
              }
              return field;
            });
          }
          if (resp.multiplesApoderados) {
            const apoderadosTransformados = resp.multiplesApoderados.map(
              apoderado => this.transformarApoderado(apoderado)
            );
            this.apoderados = [...apoderadosTransformados];
            this.showTipoDocApoderados();
          }
          if (resp.demandante) {
            const demandanteTransformado = resp.demandante.map(demandante =>
              this.transformarDatosAFormaDemandante(demandante)
            );
            this.demandantes = [...demandanteTransformado];
            this.showTipoDocDemandantes();
          }
          if (resp.demandado) {
            const demandadoTransformado = resp.demandado.map(demandado =>
              this.transformarDatosAFormaDemandado(demandado)
            );
            this.demandados = [...demandadoTransformado];
            this.showTipoDocDemandados();
          }
        }
      });
  }

  getIdAsuntos(nombre: string) {
    let nombreModificado: string = nombre.split(':')[0];
    const asunto = this.listaTipoAsunto.find(
      (elemento: ListaValorResponseDto) => elemento.Valor === nombreModificado
    );

    return asunto?.Id!;
  }

  transformarApoderado(apoderado: TramiteDTO['multiplesApoderados'][0]): any {
    return {
      id: apoderado.id,
      idTipoPersona: apoderado.idTipoPersona,
      idTipoIdentificacion: apoderado.idTipoIdentificacion,
      identificacion: apoderado.identificacion,
      primerNombre: apoderado.primerNombre,
      segundoNombre: apoderado.segundoNombre,
      primerApellido: apoderado.primerApellido,
      segundoApellido: apoderado.segundoApellido,
      tarjetaProfesional: apoderado.tarjetaProfesional ?? null,
      correoElectronico: apoderado.correoElectronico,
      telefonoPrincipal: apoderado.telefonoPrincipal,
      municipio: {
        id: apoderado.municipio.id,
        idPais: apoderado.municipio.idPais,
        idDepartamento: apoderado.municipio.idDepartamento,
        nombre: apoderado.municipio.nombre,
        departamento: apoderado.municipio.departamento,
        pais: apoderado.municipio.idPais,
      },
      country: apoderado.municipio.idPais,
      direccionPersona: apoderado.direccionPersona.map(
        (direccion: { direccionNotificacion: string }) => ({
          direccionNotificacion: direccion.direccionNotificacion,
        })
      ),
      ciudadExtranjero: apoderado.ciudadExtranjero ?? undefined,
      departamentoExtranjero: apoderado.departamentoExtranjero ?? undefined,
    };
  }

  transformarDatosAFormaDemandante(data: any): PersonaDto {
    if (data.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      return {
        id: data.id,
        idTipoPersona: data.idTipoPersona,
        idTipoIdentificacion: data.idTipoIdentificacion,
        identificacion: data.identificacion,
        primerNombre: data.primerNombre,
        segundoNombre: data.segundoNombre ?? undefined,
        primerApellido: data.primerApellido,
        segundoApellido: data.segundoApellido ?? undefined,
        idSexo: data.idSexo ?? undefined,
        fechaNacimiento: this.setDateValue(data.fechaNacimiento) ?? undefined,
        nacionalidad: data.nacionalidad ?? undefined,
        nacionalidadDoble: data.nacionalidadDoble ?? undefined,
        municipio: {
          id: data.municipio?.id,
          idDepartamento: data.municipio?.idDepartamento,
        },
        direccionPersona: data.direccionPersona?.map(
          (
            direccion: { direccionNotificacion: string; esPrimaria: boolean },
            index: number
          ) => ({
            direccionNotificacion: direccion.direccionNotificacion ?? undefined,
            esPrimaria: direccion.esPrimaria,
          })
        ),
        telefonoPrincipal: data.telefonoPrincipal ?? undefined,
        fax: data.fax ?? undefined,
        apartadoAereo: data.apartadoAereo ?? undefined,
        correoElectronico: data.correoElectronico ?? undefined,
        paginaWeb: data.paginaWeb ?? undefined,
        country: data.municipio?.idPais ?? undefined,
        ciudadExtranjero: data.ciudadExtranjero ?? undefined,
        departamentoExtranjero: data.departamentoExtranjero ?? undefined,
      };
    } else {
      const datosRepresentanteLegal: PersonaDto = {
        id: data.datosRepresentanteLegal?.id,
        idTipoPersona: data.datosRepresentanteLegal?.idTipoPersona,
        idTipoIdentificacion:
          data.datosRepresentanteLegal?.idTipoIdentificacion,
        identificacion: data.datosRepresentanteLegal?.identificacion,
        primerNombre: data.datosRepresentanteLegal?.primerNombre ?? undefined,
        segundoNombre: data.datosRepresentanteLegal?.segundoNombre ?? undefined,
        primerApellido:
          data.datosRepresentanteLegal?.primerApellido ?? undefined,
        segundoApellido:
          data.datosRepresentanteLegal?.segundoApellido ?? undefined,
        idSexo: data.datosRepresentanteLegal?.idSexo ?? undefined,
        fechaNacimiento:
          this.setDateValue(data.datosRepresentanteLegal?.fechaNacimiento) ??
          undefined,
        correoElectronico:
          data.datosRepresentanteLegal?.correoElectronico ?? undefined,
        nacionalidad: data.datosRepresentanteLegal?.nacionalidad ?? undefined,
        nacionalidadDoble:
          data.datosRepresentanteLegal?.nacionalidadDoble ?? undefined,
        municipio: {
          id: data.datosRepresentanteLegal?.municipio?.id ?? undefined,
          idDepartamento:
            data.datosRepresentanteLegal?.municipio?.idDepartamento ??
            undefined,
        },
        ciudadExtranjero: data.ciudadExtranjero ?? undefined,
        departamentoExtranjero: data.departamentoExtranjero ?? undefined,
        direccionPersona: data.datosRepresentanteLegal?.direccionPersona?.map(
          (
            direccion: { direccionNotificacion: string; esPrimaria: boolean },
            index: number
          ) => ({
            direccionNotificacion: direccion.direccionNotificacion ?? undefined,
            esPrimaria: direccion.esPrimaria,
          })
        ),
        telefonoPrincipal:
          data.datosRepresentanteLegal?.telefonoPrincipal ?? undefined,
        fax: data.datosRepresentanteLegal?.fax ?? undefined,
        apartadoAereo: data.datosRepresentanteLegal?.apartadoAereo ?? undefined,
        correoElectronicoSecundario:
          data.datosRepresentanteLegal?.correoElectronicoSecundario ??
          undefined,
        countryRl: data.datosRepresentanteLegal?.municipio?.idPais ?? undefined,
      };
      return {
        id: data.id,
        idTipoPersona: 2,
        idTipoIdentificacion: Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT,
        identificacion: data.identificacion ?? undefined,
        razonSocial: data.razonSocial ?? undefined,
        tipoSociedad: {
          id: data.tipoSociedad ?? undefined,
          valor: data.tipoSociedad
            ? this.listaTipoSociedad.find(
              element => element.Id === data.tipoSociedad
            )?.Valor || ''
            : undefined,
        },
        municipio: {
          id: data.municipio?.id,
          idDepartamento: data.municipio?.idDepartamento ?? undefined,
        },
        direccionPersona: [
          {
            direccionNotificacion:
              data.direccionPersona?.[0]?.direccionNotificacion ?? undefined,
          },
        ],
        ciudadExtranjero: data.ciudadExtranjero ?? undefined,
        departamentoExtranjero: data.departamentoExtranjero ?? undefined,
        telefonoPrincipal: data.telefonoPrincipal ?? undefined,
        fax: data.fax ?? undefined,
        apartadoAereo: data.apartadoAereo ?? undefined,
        correoElectronico: data.correoElectronico ?? undefined,
        paginaWeb: data.paginaWeb ?? undefined,
        country: data.municipio?.idPais ?? undefined,
        datosRepresentanteLegal: datosRepresentanteLegal,
      };
    }
  }

  transformarDatosAFormaDemandado(data: any): PersonaDto {
    if (data.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      return {
        id: data.id,
        idTipoPersona: data.idTipoPersona,
        idTipoIdentificacion: data.idTipoIdentificacion,
        identificacion: data.identificacion,
        primerNombre: data.primerNombre,
        segundoNombre: data.segundoNombre ?? undefined,
        primerApellido: data.primerApellido,
        segundoApellido: data.segundoApellido ?? undefined,
        municipio: {
          id: data.municipio?.id,
          idDepartamento: data.municipio?.idDepartamento,
        },
        ciudadExtranjero: data.ciudadExtranjero ?? undefined,
        departamentoExtranjero: data.departamentoExtranjero ?? undefined,
        direccionPersona: data.direccionPersona?.map(
          (direccion: {
            direccionDomicilio: string;
            direccionNotificacion: string;
          }) => ({
            direccionNotificacion: direccion.direccionNotificacion ?? undefined,
          })
        ),
        correoElectronico: data.correoElectronico ?? undefined,
        country: data.municipio?.idPais ?? undefined,
      };
    } else {
      return {
        id: data.id,
        idTipoPersona: 2,
        idTipoIdentificacion: Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT,
        identificacion: data.identificacion ?? undefined,
        razonSocial: data.razonSocial ?? undefined,
        tipoSociedad: {
          id: data.tipoSociedad ?? undefined,
          valor: data.tipoSociedad
            ? this.listaTipoSociedad.find(
              element => element.Id === data.tipoSociedad
            )?.Valor || ''
            : undefined,
        },
        municipio: {
          id: data.municipio?.id,
          idDepartamento: data.municipio?.idDepartamento ?? undefined,
        },
        ciudadExtranjero: data.ciudadExtranjero ?? undefined,
        departamentoExtranjero: data.departamentoExtranjero ?? undefined,
        direccionPersona: data.direccionPersona?.map(
          (direccion: {
            direccionDomicilio: string;
            direccionNotificacion: string;
          }) => ({
            direccionNotificacion: direccion.direccionNotificacion ?? undefined,
          })
        ),
        correoElectronico: data.correoElectronico ?? undefined,
        country: data.municipio?.idPais ?? undefined,
        datosRepresentanteLegal: null,
      };
    }
  }

  setDateValue(dateString: string): string | undefined {
    if (!dateString) return; // Manejo de caso nulo o vacío
    const date = new Date(dateString);
    const formattedDate = date.toISOString().split('T')[0]; // Formato yyyy-MM-dd
    return formattedDate;
  }

  inicializarFormularioAsunto() {
    // Asunto
    this.asunto = [
      {
        name: 'asunto',
        label: this.asuntosText['asuntos-mercantiles']['asunto'],
        type: 'select',
        required: true,
        visible: true,
        width: '12',
        options: [],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
        },
      },
    ];
  }

  inicializarFormularioDemandantes() {
    // Tipo Persona demandante
    this.tipoPersonaDemandante = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['informacion-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'tipoPersonaDemandante',
        label: this.comunText['tipo-demandante'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['persona-natural-select'] },
          { Id: 2, Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];
    // Demandante Persona Natural
    this.demandantePN = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles'][
          'cuentanos-demandante-natural'
          ],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          required: this.comunText['primer-apellido-required'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'genero',
        label: this.asuntosText['asuntos-mercantiles']['genero'],
        type: 'select',
        required: true,
        width: '6',
        options: [],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['genero-required'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: true,
        placeholder: 'Ingrese la Fecha de nacimiento',
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['fecha-nacimiento-required'],
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_REQUERIDOS} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'nacionalidadPerson',
        label: this.asuntosText['asuntos-mercantiles']['nacionalidad'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required:
            this.asuntosText['asuntos-mercantiles']['nacionalidad-required'],
          coinciden:
            this.asuntosText['asuntos-mercantiles']['nacionalidad-coinciden'],
        },
      },
      {
        name: 'nacionalidadDouble',
        label: this.asuntosText['asuntos-mercantiles']['doble-nacionalidad'],
        type: 'select',
        required: false,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          coinciden:
            this.asuntosText['asuntos-mercantiles'][
            'doble-nacionalidad-coincide'
            ],
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['vive-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingresa el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamentoDemandantePN',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.asuntosText['asuntos-mercantiles']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandantePN',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.asuntosText['asuntos-mercantiles']['escriba-municipio'],
      },
      {
        name: 'direccionPersona',
        label: this.asuntosText['asuntos-mercantiles']['direccion-domicilio'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'addressNotificationJudicial',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'telefono',
        label: this.asuntosText['asuntos-mercantiles']['telefono-celular'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
      {
        name: 'fax',
        label: this.asuntosText['asuntos-mercantiles']['fax'],
        type: 'text',
        required: false,
        placeholder: this.asuntosText['asuntos-mercantiles']['fax-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(20),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.asuntosText['asuntos-mercantiles']['fax-pattern'],
          maxlength: this.asuntosText['asuntos-mercantiles']['fax-maxlength'],
        },
      },
      {
        name: 'apartadoAereo',
        label: this.asuntosText['asuntos-mercantiles']['apartado-aereo'],
        type: 'text',
        required: false,
        placeholder:
          this.asuntosText['asuntos-mercantiles']['apartado-aereo-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles']['apartado-aereo-maxlength'],
        },
      },
      {
        name: 'email',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'paginaWeb',
        label: this.asuntosText['asuntos-mercantiles']['pagina-web'],
        type: 'text',
        required: false,
        placeholder:
          this.asuntosText['asuntos-mercantiles']['pagina-web-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_PAGINA_WEB),
        ],
        errorMessages: {
          pattern:
            this.asuntosText['asuntos-mercantiles']['pagina-web-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles']['pagina-web-maxlength'],
        },
      },
    ];
    // Demantante Persona Juridica
    this.demandantePJ = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['sobre-demandante-juridica'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.asuntosText['asuntos-mercantiles']['nit-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(9),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['nit-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['nit-maxlength'],
          pattern: this.asuntosText['asuntos-mercantiles']['nit-pattern'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
        },
      },
      {
        name: 'tipoSociedad',
        label: this.comunText['tipo-sociedad'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-sociedad-required'] },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['vive-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingrese el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamentoDemandantePJ',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.asuntosText['asuntos-mercantiles']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandantePJ',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.asuntosText['asuntos-mercantiles']['escriba-municipio'],
      },
      {
        name: 'addressNotificationJudicial',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'telefono',
        label: this.asuntosText['asuntos-mercantiles']['telefono-celular'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
      {
        name: 'fax',
        label: this.asuntosText['asuntos-mercantiles']['fax'],
        type: 'text',
        required: false,
        placeholder: this.asuntosText['asuntos-mercantiles']['fax-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(20),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.asuntosText['asuntos-mercantiles']['fax-pattern'],
          maxlength: this.asuntosText['asuntos-mercantiles']['fax-maxlength'],
        },
      },
      {
        name: 'apartadoAereo',
        label: this.asuntosText['asuntos-mercantiles']['apartado-aereo'],
        type: 'text',
        required: false,
        placeholder:
          this.asuntosText['asuntos-mercantiles']['apartado-aereo-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles']['apartado-aereo-maxlength'],
        },
      },
      {
        name: 'email',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'paginaWeb',
        label: this.asuntosText['asuntos-mercantiles']['pagina-web'],
        type: 'text',
        required: false,
        placeholder:
          this.asuntosText['asuntos-mercantiles']['pagina-web-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_PAGINA_WEB),
        ],
        errorMessages: {
          pattern:
            this.asuntosText['asuntos-mercantiles']['pagina-web-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles']['pagina-web-maxlength'],
        },
      },
      /** Representante legal */
      {
        isSubtitle: true,
        subtitleText: this.comunText['subtitulo-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'primerNombreRl',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombreRl',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellidoRl',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoApellidoRl',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'genero',
        label: this.asuntosText['asuntos-mercantiles']['genero'],
        type: 'select',
        required: true,
        width: '6',
        options: [],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['genero-required'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        placeholder: 'Ingrese la Fecha de nacimiento',
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['fecha-nacimiento-required'],
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_REQUERIDOS} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'typeOfDocumentRl',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocumentRl',
        label: this.comunText['numero-documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'emailRl',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'nacionalidadPerson',
        label: this.asuntosText['asuntos-mercantiles']['nacionalidad'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required:
            this.asuntosText['asuntos-mercantiles']['nacionalidad-required'],
          coinciden:
            this.asuntosText['asuntos-mercantiles']['nacionalidad-coinciden'],
        },
      },
      {
        name: 'nacionalidadDouble',
        label: this.asuntosText['asuntos-mercantiles']['doble-nacionalidad'],
        type: 'select',
        required: false,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          coinciden:
            this.asuntosText['asuntos-mercantiles'][
            'doble-nacionalidad-coincide'
            ],
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['vive-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'countryRl',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departamentRl',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingrese el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipalityRl',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamentoRL',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'countryRl',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.asuntosText['asuntos-mercantiles']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioRL',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'countryRl',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.asuntosText['asuntos-mercantiles']['escriba-municipio'],
      },
      {
        name: 'direccionPersona',
        label: this.asuntosText['asuntos-mercantiles']['direccion-domicilio'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'addressNotificationJudicialRl',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'telefonoRl',
        label: this.asuntosText['asuntos-mercantiles']['telefono-celular'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(10),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles']['telefono-maxlength'],
        },
      },
      {
        name: 'faxRl',
        label: this.asuntosText['asuntos-mercantiles']['fax'],
        type: 'text',
        required: false,
        placeholder: this.asuntosText['asuntos-mercantiles']['fax-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(20),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.asuntosText['asuntos-mercantiles']['fax-pattern'],
          maxlength: this.asuntosText['asuntos-mercantiles']['fax-maxlength'],
        },
      },
      {
        name: 'apartadoAereoRl',
        label: this.asuntosText['asuntos-mercantiles']['apartado-aereo'],
        type: 'text',
        required: false,
        placeholder:
          this.asuntosText['asuntos-mercantiles']['apartado-aereo-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles']['apartado-aereo-maxlength'],
        },
      },
      {
        name: 'emailNotificacionRl',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
  }

  inicializarFormularioApoderado() {
    // Apoderado
    this.apoderado = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['sobre-apoderado'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        personTypeId: '3',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'tarjetaProfesional',
        label: this.comunText['tarjeta-profesional'],
        type: 'text',
        required: true,
        placeholder: this.comunText['tarjeta-profesional-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(9),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['tarjeta-profesional-required'],
          pattern: this.comunText['tarjeta-profesional-pattern'],
          maxlength:
            this.asuntosText['asuntos-mercantiles'][
            'tarjeta-profesional-maxlength'
            ],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.asuntosText['asuntos-mercantiles']['telefono-celular'],
        type: 'text',
        required: false,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingrese el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamentoApoderado',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.asuntosText['asuntos-mercantiles']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioApoderado',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.asuntosText['asuntos-mercantiles']['escriba-municipio'],
      },
      {
        name: 'addressNotificationJudicial',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
    ];
  }

  inicializarFormulariosDemandados() {
    // Tipo persona demandada
    this.tipoPersonaDemandanda = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles'][
          'informacion-persona-demandada'
          ],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'tipoPersonaDemandada',
        label: this.comunText['tipo-demandado'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['persona-natural-select'] },
          { Id: 2, Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];
    // Demandanda Persona Natural
    this.demandadaPN = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['sobre-demandada-natural'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingrese el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamentoDemandadoPN',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.asuntosText['asuntos-mercantiles']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandadoPN',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.asuntosText['asuntos-mercantiles']['escriba-municipio'],
      },
      {
        name: 'addressNotificationJudicial',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: false,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
    // Demantante Persona Juridica
    this.demandadaPJ = [
      {
        isSubtitle: true,
        subtitleText:
          this.asuntosText['asuntos-mercantiles']['sobre-demandada-juridica'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.asuntosText['asuntos-mercantiles']['nit-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(9),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['nit-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['nit-maxlength'],
          pattern: this.asuntosText['asuntos-mercantiles']['nit-pattern'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
        },
      },
      {
        name: 'tipoSociedad',
        label: this.comunText['tipo-sociedad'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-sociedad-required'] },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required:
            this.asuntosText['asuntos-mercantiles']['nacionalidad-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingrese el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamentoDemandadoPJ',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.asuntosText['asuntos-mercantiles']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandadoPJ',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.asuntosText['asuntos-mercantiles']['campo-required'],
          maxlength: this.asuntosText['asuntos-mercantiles']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.asuntosText['asuntos-mercantiles']['escriba-municipio'],
      },
      {
        name: 'addressNotificationJudicial',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
  }

  getListaGeneros() {
    const demandantePN = this.demandantePN.find(
      field => field.name == 'genero'
    );
    const demandanteRL = this.demandantePJ.find(
      field => field.name == 'genero'
    );
    this.listaServices.getGenero().subscribe((generos: ListaDTO[]) => {
      const tiposGeneros = generos.map(genero => ({
        Id: genero.Id,
        Nombre: genero.Valor,
      }));
      if (demandantePN != undefined) {
        demandantePN.options = tiposGeneros;
      }
      if (demandanteRL != undefined) {
        demandanteRL.options = tiposGeneros;
      }
    });
  }

  getListaSociedades() {
    this.listaServices
      .listaValor(ListaValorConstants.TipoSociedadIca)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.listaTipoSociedad = data;

        this.demandantePJ = this.demandantePJ.map(field => {
          if (field.name === 'tipoSociedad') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
        this.demandadaPJ = this.demandadaPJ.map(field => {
          if (field.name === 'tipoSociedad') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });
  }

  getListaAsuntos() {
    this.listaServices
      .listaValor(Constants.LISTAS.SSM_ASUNTO)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.listaTipoAsunto = data;

        this.asunto = this.asunto.map(field => {
          if (field.name === 'asunto') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });
  }

  getTypeDocuments() {
    this.listaServices
      .getDocumentTypeList()
      .subscribe((documentTypes: TipoDocumentoDto[]) => {
        this.listaTiposDocumento = documentTypes.map(documentType => ({
          Id: documentType.Id,
          TipoDocumento: documentType.Tipo_Documento,
        }));
      });
  }

  // Metodo que llama al servicio de paises
  getCountries(): void {
    const nacionalidadPn = this.demandantePN.find(
      field => field.name == 'nacionalidadPerson'
    );
    const nacionalidadDoblePn = this.demandantePN.find(
      field => field.name == 'nacionalidadDouble'
    );
    const nacionalidadRl = this.demandantePJ.find(
      field => field.name == 'nacionalidadPerson'
    );
    const nacionalidadDobleRl = this.demandantePJ.find(
      field => field.name == 'nacionalidadDouble'
    );
    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
      const formattedCountries = countries.map(country => ({
        Id: country.Id,
        Nombre: country.Nombre,
        Codigo: country.Codigo,
      }));
      if (nacionalidadPn != undefined) {
        nacionalidadPn.options = formattedCountries;
      }
      if (nacionalidadDoblePn != undefined) {
        nacionalidadDoblePn.options = formattedCountries;
      }
      if (nacionalidadRl != undefined) {
        nacionalidadRl.options = formattedCountries;
      }
      if (nacionalidadDobleRl != undefined) {
        nacionalidadDobleRl.options = formattedCountries;
      }
    });
  }

  // Obtener anexos de tramite
  getAnexosTramite(idTramite: number) {
    this.cargueArchivosTramiteService
      .getTipoArchivosTramite(idTramite)
      .subscribe((response: any) => {
        this.anexosTramiteObligatorios = response.filter(
          (anexo: any) => anexo.requerido === true
        );
      });
  }

  // Función que maneja el evento del formulario asunto
  onSubmitAsunto(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName === 'asunto') {
      this.mostrarTipoPersonaDemandante = true;
      this.formTipoAsunto = event.form;
    }
    if (event.form?.valid) {
      this.formAsuntoValido = true;
      if (this.idTramite == null) {
        this.getData();
      }
    } else {
      this.formAsuntoValido = false;
    }
  }

  guardarAsunto() {
    this.onSubmitCompiladoFormularios(false);
  }

  // Función que maneja el evento del formulario tipo persona
  onSubmitTipoPersonaDemandante(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (this.formAsuntoValido) {
      if (event.controlName === 'tipoPersonaDemandante') {
        this.idTipoPersonaSeleccionadoDemandante = event.form.get(
          event.controlName
        )?.value;
        this.formTipoPersonaDemandante = event.form;
      }
      if (this.idTipoPersonaSeleccionadoDemandante == 1) {
        this.mostrarFomularioNaturalDemandante = true;
        this.mostrarFomularioJuridicoDemandante = false;
      } else if (this.idTipoPersonaSeleccionadoDemandante == 2) {
        this.mostrarFomularioNaturalDemandante = false;
        this.mostrarFomularioJuridicoDemandante = true;
      } else {
        this.mostrarFomularioNaturalDemandante = false;
        this.mostrarFomularioJuridicoDemandante = false;
        event.form?.reset();
      }
      if (event.form?.valid) {
        this.formTipoPersonaValidoDemandante = true;
      }
    }
  }

  // Función que maneja el evento del formulario de demandante PN
  onSubmitDatosDemandantePN(form: FormGroup) {
    this.onDemandantes = false;
    this.formDemandanteNatural = form;
    let nacionalidad =
      this.formDemandanteNatural?.get('nacionalidadPerson')?.value;
    let nacionalidadDoble =
      this.formDemandanteNatural?.get('nacionalidadDouble')?.value;
    if (
      nacionalidad == nacionalidadDoble &&
      nacionalidad != undefined &&
      nacionalidadDoble != undefined
    ) {
      this.formDemandanteNatural.get('nacionalidadPerson')?.setErrors({
        coinciden:
          this.asuntosText['asuntos-mercantiles']['nacionalidad-coinciden'],
      });
      this.formDemandanteNatural.get('nacionalidadPerson')?.markAsTouched();
      this.formDemandanteNatural.get('nacionalidadDouble')?.setErrors({
        coinciden:
          this.asuntosText['asuntos-mercantiles'][
          'doble-nacionalidad-coincide'
          ],
      });
      this.formDemandanteNatural?.get('nacionalidadDouble')?.markAsTouched();
    } else {
      this.formDemandanteNatural?.get('nacionalidadPerson')?.setErrors(null);
      this.formDemandanteNatural?.get('nacionalidadDouble')?.setErrors(null);
    }

    const nacionalidadControl =
      this.formDemandanteNatural?.get('nacionalidadPerson');
    if (
      nacionalidadControl?.value == undefined ||
      nacionalidadControl?.value == null
    ) {
      nacionalidadControl?.setErrors({
        required:
          this.asuntosText['asuntos-mercantiles']['nacionalidad-required'],
      });
      this.formDemandanteNatural?.get('nacionalidadPerson')?.markAsTouched();
    } else {
      this.formDemandanteNatural?.get('nacionalidadPerson')?.setErrors(null);
    }
    if (form?.valid) {
      this.formDatosDemandantePnValido = true;
    }
  }

  // Función que maneja el evento del formulario de demandante PJ
  onSubmitDatosDemandantePJ(form: FormGroup) {
    this.onDemandantes = false;
    this.formDemandanteJuridico = form;
    let nacionalidad =
      this.formDemandanteJuridico?.get('nacionalidadPerson')?.value;
    let nacionalidadDoble =
      this.formDemandanteJuridico?.get('nacionalidadDouble')?.value;
    if (
      nacionalidad == nacionalidadDoble &&
      nacionalidad != undefined &&
      nacionalidadDoble != undefined
    ) {
      this.formDemandanteJuridico.get('nacionalidadPerson')?.setErrors({
        coinciden:
          this.asuntosText['asuntos-mercantiles']['nacionalidad-coinciden'],
      });
      this.formDemandanteJuridico.get('nacionalidadPerson')?.markAsTouched();
      this.formDemandanteJuridico.get('nacionalidadDouble')?.setErrors({
        coinciden:
          this.asuntosText['asuntos-mercantiles'][
          'doble-nacionalidad-coincide'
          ],
      });
      this.formDemandanteJuridico.get('nacionalidadDouble')?.markAsTouched();
    } else {
      this.formDemandanteJuridico.get('nacionalidadPerson')?.setErrors(null);
      this.formDemandanteJuridico.get('nacionalidadDouble')?.setErrors(null);
    }
    const nacionalidadControl =
      this.formDemandanteJuridico.get('nacionalidadPerson');
    if (
      nacionalidadControl?.value == undefined ||
      nacionalidadControl?.value == null
    ) {
      nacionalidadControl?.setErrors({
        required:
          this.asuntosText['asuntos-mercantiles']['nacionalidad-required'],
      });
      this.formDemandanteJuridico.get('nacionalidadPerson')?.markAsTouched();
    } else {
      this.formDemandanteJuridico.get('nacionalidadPerson')?.setErrors(null);
    }
    if (form?.valid) {
      this.formDatosDemandantePjValido = true;
    }
    this.mostrarCamposRequeridos(form);
  }

  validarFormDemandantes(): boolean {
    if (this.idTipoPersonaSeleccionadoDemandante == 1) {
      return this.formDatosDemandantePnValido;
    } else {
      return this.formDatosDemandantePjValido;
    }
  }

  guardarDatosDemandante() {
    if (this.mostrarFomularioNaturalDemandante) {
      this.guardarDemandante(this.formDemandanteNatural, 1, true);
    } else if (this.mostrarFomularioJuridicoDemandante) {
      this.guardarDemandante(this.formDemandanteJuridico, 2, true);
    }
  }

  validarFormularioDemandanteN($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    if (this.isEditarDemandante == false) {
      if (
        $event.controlName == 'numberOfDocument' ||
        $event.controlName == 'typeOfDocument'
      ) {
        if (idTipoDocumento !== null && identificacion !== null) {
          let isEmptyApoderado: boolean = this.searchInApoderado(
            idTipoDocumento,
            identificacion
          );
          let isEmptyDemandado: boolean = this.searchInDemandados(
            idTipoDocumento,
            identificacion
          );
          let isEmptyDemandantes: boolean = this.searchInDemandantes(
            idTipoDocumento,
            identificacion
          );
          if (isEmptyApoderado && isEmptyDemandado && isEmptyDemandantes) {
            this.existePersonaDemandante = false;
            // this.validarUsuario(
            //   idTipoDocumento,
            //   identificacion,
            //   formGroup,
            //   'demandante'
            // );
          } else if (isEmptyDemandantes == false) {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          } else if (isEmptyDemandado == false) {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandado']
            );
          } else if (isEmptyApoderado == false) {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-apoderado']
            );
          }
        }
      }
    }

    const numeroDocumentoDemandandanteN = this.demandantePN.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoDemandandanteN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandandanteN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }
        formGroup?.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if ($event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamentoDemandantePN']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandantePN']?.removeValidators(
          Validators.required
        );
        formGroup?.get('otroMunicipioDemandantePN')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoDemandantePN')?.updateValueAndValidity();
      } else {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandante.push(
            formGroup?.controls['country'].value
          );
          if (this.auxIdCountryDemandante.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandante[
              this.auxIdCountryDemandante.length - 2
              ];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandantePN'].setValue('');
          formGroup?.controls['otroMunicipioDemandantePN'].setValue('');
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandantePN']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandantePN']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandantePN']?.markAsDirty();
        formGroup?.controls['otroMunicipioDemandantePN']?.markAllAsTouched();
        formGroup?.get('otroMunicipioDemandantePN')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoDemandantePN')?.updateValueAndValidity();
        this.demandantePN.forEach((field: FormField) => {
          if (
            [
              'otroMunicipioDemandantePN',
              'otroDepartamentoDemandantePN',
            ].includes(field.name)
          ) {
            field.required = true;
          }
        });
      }
    }
  }

  validarFormularioDemandanteJ($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    let identificacionRl: string = formGroup?.get('numberOfDocumentRl')?.value;
    let idTipoDocumentoRl: number = +formGroup?.get('typeOfDocumentRl')?.value;
    if (this.isEditarDemandante == false) {
      if ($event.controlName == 'numberOfDocument') {
        if (identificacion !== null) {
          let isEmptyApoderado: boolean = this.searchInApoderado(
            3,
            identificacion
          );
          let isEmptyDemandado: boolean = this.searchInDemandados(
            3,
            identificacion
          );
          let isEmptyDemandantes: boolean = this.searchInDemandantes(
            3,
            identificacion
          );
          if (isEmptyApoderado && isEmptyDemandado && isEmptyDemandantes) {
            this.existePersonaDemandante = false;
            // this.validarUsuario(3, identificacion, formGroup, 'demandante');
          } else if (isEmptyDemandantes == false) {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          } else if (isEmptyDemandado == false) {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandado']
            );
          } else if (isEmptyApoderado == false) {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-apoderado']
            );
          }
        }
      }
    }
    const numeroDocumentoRl = this.demandantePJ.find(
      field => field.name == 'numberOfDocumentRl'
    );
    const documentNumberRl = formGroup?.get('numberOfDocumentRl');
    if (
      $event.controlName == 'typeOfDocumentRl' ||
      $event.controlName == 'numberOfDocumentRl'
    ) {
      if (idTipoDocumentoRl !== null && identificacionRl !== null) {
        if (idTipoDocumentoRl == 4) {
          if (numeroDocumentoRl != undefined) {
            documentNumberRl?.setValidators([
              Validators.maxLength(8),
              Validators.pattern(
                Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
              ),
            ]);
            numeroDocumentoRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else {
          if (numeroDocumentoRl != undefined) {
            documentNumberRl?.setValidators([
              Validators.maxLength(12),
              Validators.minLength(4),
              Validators.pattern(Constants.REGEX_TELEFONO),
            ]);
            numeroDocumentoRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoRl.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }

        formGroup?.get('numberOfDocumentRl')?.updateValueAndValidity();
      }
    }
    // Seccion PJ Demandante
    if ($event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamentoDemandantePJ']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandantePJ']?.removeValidators(
          Validators.required
        );
      } else {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandante.push(
            formGroup?.controls['country'].value
          );
          if (this.auxIdCountryDemandante.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandante[
              this.auxIdCountryDemandante.length - 2
              ];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandantePJ'].setValue('');
          formGroup?.controls['otroMunicipioDemandantePJ'].setValue('');
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandantePJ']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandantePJ']?.markAsDirty();
        formGroup?.controls['otroDepartamentoDemandantePJ']?.markAllAsTouched();
        formGroup?.controls['otroMunicipioDemandantePJ']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandantePJ']?.markAsDirty();
        formGroup?.controls['otroMunicipioDemandantePJ']?.markAllAsTouched();
        formGroup?.get('otroMunicipioDemandantePJ')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoDemandantePJ')?.updateValueAndValidity();
        this.demandantePJ.forEach((field: FormField) => {
          if (
            [
              'otroMunicipioDemandantePJ',
              'otroDepartamentoDemandantePJ',
            ].includes(field.name)
          ) {
            field.required = true;
          }
        });
      }
    }
    // Seccion RL Demandante
    if ($event.controlName == 'countryRl') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('countryRl')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departamentRl']?.addValidators(
          Validators.required
        );
        formGroup?.controls['municipalityRl']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoRL']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioRL']?.removeValidators(
          Validators.required
        );
      } else {
        let clearInputs: boolean = false;
        if (formGroup?.controls['countryRl'].value) {
          this.auxIdCountryDemandanteRl.push(
            formGroup?.controls['countryRl'].value
          );
          if (this.auxIdCountryDemandanteRl.length > 1) {
            clearInputs =
              formGroup?.controls['countryRl'].value !=
              this.auxIdCountryDemandanteRl[
              this.auxIdCountryDemandanteRl.length - 2
              ];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoRL'].setValue('');
          formGroup?.controls['otroMunicipioRL'].setValue('');
        }
        formGroup?.controls['departamentRl']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipalityRl']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoRL']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoRL']?.markAsDirty();
        formGroup?.controls['otroDepartamentoRL']?.markAllAsTouched();
        formGroup?.controls['otroMunicipioRL']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioRL']?.markAsDirty();
        formGroup?.controls['otroMunicipioRL']?.markAllAsTouched();
        formGroup?.get('otroMunicipioRL')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoRL')?.updateValueAndValidity();
        this.demandantePJ.forEach((field: FormField) => {
          if (['otroMunicipioRL', 'otroDepartamentoRL'].includes(field.name)) {
            field.required = true;
          }
        });
      }
    }
  }

  guardarDemandante(
    form: FormGroup,
    tipoPersona: number,
    esProvisional: boolean
  ) {
    const esNatural: boolean = tipoPersona === Constants.TIPO_PERSONA.NATURAL;
    const idPais = this.paises.find(
      item => item.Codigo == Constants.CODIGO_COLOMBIA
    )?.Id;
    if (form?.controls['country'].value == idPais) {
      form?.controls['departament'].addValidators(Validators.required);
      form?.controls['municipality'].addValidators(Validators.required);
      if (esNatural) {
        form?.controls['otroDepartamentoDemandantePN'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoDemandantePN'].updateValueAndValidity();
        form?.controls['otroMunicipioDemandantePN'].removeValidators(
          Validators.required
        );
        form?.controls['otroMunicipioDemandantePN'].updateValueAndValidity();
      } else {
        form?.controls['otroDepartamentoDemandantePJ'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoDemandantePJ'].updateValueAndValidity();
        form?.controls['otroMunicipioDemandantePJ'].removeValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoDemandantePJ'].updateValueAndValidity();
        form?.controls['otroMunicipioDemandantePJ'].updateValueAndValidity();
      }
    } else {
      form?.controls['departament'].removeValidators(Validators.required);
      form?.controls['municipality'].removeValidators(Validators.required);
      if (esNatural) {
        form?.controls['otroDepartamentoDemandantePN'].addValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoDemandantePN'].markAsDirty();
        form?.controls['otroDepartamentoDemandantePN'].markAllAsTouched();
        form?.controls['otroMunicipioDemandantePN'].addValidators(
          Validators.required
        );
        form?.controls['otroMunicipioDemandantePN'].markAsDirty();
        form?.controls['otroMunicipioDemandantePN'].markAllAsTouched();
        form?.controls['otroDepartamentoDemandantePN'].updateValueAndValidity();
        form?.controls['otroMunicipioDemandantePN'].updateValueAndValidity();
      } else {
        form?.controls['otroDepartamentoDemandantePJ'].addValidators(
          Validators.required
        );
        form?.controls['otroDepartamentoDemandantePJ'].markAsDirty();
        form?.controls['otroDepartamentoDemandantePJ'].markAllAsTouched();
        form?.controls['otroMunicipioDemandantePJ'].addValidators(
          Validators.required
        );
        form?.controls['otroMunicipioDemandantePJ'].markAsDirty();
        form?.controls['otroMunicipioDemandantePJ'].markAllAsTouched();
        form?.controls['otroDepartamentoDemandantePJ'].updateValueAndValidity();
        form?.controls['otroMunicipioDemandantePJ'].updateValueAndValidity();
      }
    }

    const demandante = this.crearDemandante(form, esNatural);
    const valido = this.esDemandanteValido(demandante);
    if (!valido) {
      this.markFormsAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    if (esProvisional) {
      if (this.isEditarDemandante) {
        this.alertaModalService.confirmacion(
          this.alertaText['asuntos-alertas']['editar-datos'],
          '',
          () => {
            demandante.id = this.demandantes[this.indiceArrayDemandante].id;
            this.agregarDemandanteEditado(demandante, esProvisional);
          },
          () => {
            this.limpiarFormDemandantes(demandante);
            this.isEditarDemandante = false;
            this.alertaModalService.exito(
              this.alertaText['asuntos-alertas']['operacion-cancelada']
            );
          }
        );
      } else {
        this.agregarDemandante(demandante, esProvisional);
      }
    } else {
      if (this.existePersonaDemandante == false) {
        if (this.isEditarDemandante) {
          demandante.id = this.demandantes[this.indiceArrayDemandante].id;
          this.agregarDemandanteEditado(demandante, false);
        } else {
          if (this.existeDemandante(demandante)) {
            this.alertaModalService.error(
              this.alertaText['error'],
              this.alertaText['demandante-ya-agregado']
            );
          } else {
            // Se comenta para que no guarde abogados sin data alguna
            // se obliga al usuario dar click en agregar abogado
            // this.mostrarApoderado = true;
            this.mostrarTipoPersonaDemandante = false;
            this.agregarDemandante(demandante, false);
          }
        }
      } else {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['sic-comp-desleal-alertas']['existe']
        );
      }
    }

    this.auxIdCountryDemandante = [];
  }

  crearDemandante(form: FormGroup, esNatural: boolean): PersonaDto {
    if (esNatural) {
      return {
        idTipoPersona: 1,
        idTipoIdentificacion: +form.get('typeOfDocument')?.value,
        identificacion: String(form.get('numberOfDocument')?.value),
        primerNombre: form.get('primerNombre')?.value,
        segundoNombre: form.get('segundoNombre')?.value,
        primerApellido: form.get('primerApellido')?.value,
        segundoApellido: form.get('segundoApellido')?.value,
        idSexo: form.get('genero')?.value,
        fechaNacimiento: form.get('fechaNacimiento')?.value,
        nacionalidad: +form.get('nacionalidadPerson')?.value,
        nacionalidadDoble: form.get('nacionalidadDouble')?.value ?? null,
        municipio: {
          id: form.get('municipality')?.value,
          idDepartamento: form.get('departament')?.value,
          idPais: form.get('country')?.value
        },
        direccionPersona: [
          {
            direccionNotificacion: form.get('addressNotificationJudicial')
              ?.value,
            esPrimaria: true,
          },
          {
            direccionNotificacion: form.get('direccionPersona')?.value,
            esPrimaria: false,
          },
        ],
        ciudadExtranjero: form.get('otroMunicipioDemandantePN')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandantePN')?.value,
        telefonoPrincipal: form.get('telefono')?.value,
        fax: form.get('fax')?.value,
        apartadoAereo: form.get('apartadoAereo')?.value,
        correoElectronico: form.get('email')?.value,
        paginaWeb: form.get('paginaWeb')?.value,
        country: form.get('country')?.value,
      };

    } else {
      const datosRepresentanteLegal: PersonaDto = {
        idTipoPersona: 1,
        idTipoIdentificacion: +form.get('typeOfDocumentRl')?.value,
        identificacion: form.get('numberOfDocumentRl')?.value,
        primerNombre: form.get('primerNombreRl')?.value,
        segundoNombre: form.get('segundoNombreRl')?.value,
        primerApellido: form.get('primerApellidoRl')?.value,
        segundoApellido: form.get('segundoApellidoRl')?.value,
        idSexo: form.get('genero')?.value,
        fechaNacimiento: form.get('fechaNacimiento')?.value,
        correoElectronico: form.get('emailRl')?.value,
        nacionalidad: +form.get('nacionalidadPerson')?.value,
        nacionalidadDoble: form.get('nacionalidadDouble')?.value ?? null,
        municipio: {
          id: form.get('municipalityRl')?.value,
          idDepartamento: form.get('departamentRl')?.value,
          idPais: form.get('countryRl')?.value
        },
        direccionPersona: [
          {
            direccionNotificacion: form.get('addressNotificationJudicialRl')
              ?.value,
            esPrimaria: true,
          },
          {
            direccionNotificacion: form.get('direccionPersona')?.value,
            esPrimaria: false,
          },
        ],
        ciudadExtranjero: form.get('otroMunicipioRL')?.value,
        departamentoExtranjero: form.get('otroDepartamentoRL')?.value,
        telefonoPrincipal: form.get('telefonoRl')?.value,
        fax: form.get('faxRl')?.value,
        apartadoAereo: form.get('apartadoAereoRl')?.value,
        correoElectronicoSecundario: form.get('emailNotificacionRl')?.value,
        countryRl: form.get('countryRl')?.value,
      };

      return {
        idTipoPersona: 2,
        idTipoIdentificacion: Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT,
        identificacion: form.get('numberOfDocument')?.value,
        razonSocial: form.get('razonSocial')?.value,
        tipoSociedad: {
          id: form.get('tipoSociedad')?.value,
          valor:
            this.listaTipoSociedad.find(
              element => element.Id === form.get('tipoSociedad')?.value
            )?.Valor || '',
        },
        municipio: {
          id: form.get('municipality')?.value,
          idDepartamento: form.get('departament')?.value,
        },
        direccionPersona: [
          {
            direccionNotificacion: form.get('addressNotificationJudicial')
              ?.value,
          },
        ],
        ciudadExtranjero: form.get('otroMunicipioDemandantePJ')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandantePJ')?.value,
        telefonoPrincipal: form.get('telefono')?.value,
        fax: form.get('fax')?.value,
        apartadoAereo: form.get('apartadoAereo')?.value,
        correoElectronico: form.get('email')?.value,
        paginaWeb: form.get('paginaWeb')?.value,
        country: form.get('country')?.value,
        datosRepresentanteLegal: datosRepresentanteLegal,
      };
    }
  }

  agregarDemandante(demandante: PersonaDto, esProvisional: boolean): void {
    this.demandantes.push(demandante);
    this.limpiarFormDemandantes(demandante);
    this.showTipoDocDemandantes();
    this.isEditarDemandante = false;
    if (esProvisional) {
      this.onSubmitCompiladoFormularios(false);
    } else {
      this.alertaModalService.exito(
        this.alertaText['agregado'],
        this.alertaText['demandante-agregado']
      );
    }
  }

  agregarDemandanteEditado(demandante: PersonaDto, esProvisional: boolean) {
    this.demandantes.splice(this.indiceArrayDemandante, 1);
    this.demandantes.push(demandante);
    this.limpiarFormDemandantes(demandante);
    this.showTipoDocDemandantes();
    this.isEditarDemandante = false;
    if (esProvisional) {
      this.onSubmitCompiladoFormularios(false);
    } else {
      this.alertaModalService.exito(
        this.alertaText['asuntos-alertas']['editado'],
        this.alertaText['asuntos-alertas']['editado-exitoso']
      );
    }
  }

  showTipoDocDemandantes() {
    this.dataTableDemandantes = this.demandantes;
    this.dataTableDemandantes.forEach((elemento: PersonaDto) => {
      if (elemento.modifyNames == undefined || elemento.modifyNames == false) {
        if (elemento.tipoIdentificacion != Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) {
          if (elemento.primerNombre) {
            elemento.primerNombre =
              this.validarContenidoNombres(elemento.primerNombre) +
              ' ' +
              this.validarContenidoNombres(elemento.segundoNombre) +
              ' ' +
              this.validarContenidoNombres(elemento.primerApellido) +
              ' ' +
              this.validarContenidoNombres(elemento.segundoApellido);
          }
          elemento.modifyNames = true;
        }
      }
      if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.CC) {
        elemento.tipoIdentificacion = 'CC';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.CE) {
        elemento.tipoIdentificacion = 'CE';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) {
        elemento.tipoIdentificacion = 'NIT';
        elemento.primerNombre = elemento.razonSocial;
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.PASAPORTE) {
        elemento.tipoIdentificacion = 'Pasaporte';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.TI) {
        elemento.tipoIdentificacion = 'TI';
      }
    });
    this.iniciarColumnasDemandantes();
  }

  limpiarFormDemandantes(demandante: PersonaDto) {
    this.idTipoPersonaSeleccionadoDemandante = undefined;
    this.tipoPersonaDemandante = this.tipoPersonaDemandante.map(
      (field: FormField) => {
        field.value = undefined;
        return field;
      }
    );
    this.idTipoPersonaSeleccionadoDemandante = null;
    if (demandante.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      this.demandantePN = this.demandantePN.map((field: FormField) => {
        field.value = undefined;
        return field;
      });
      this.mostrarFomularioNaturalDemandante = false;
    } else {
      this.demandantePJ = this.demandantePJ.map((field: FormField) => {
        field.value = undefined;
        return field;
      });
      this.mostrarFomularioJuridicoDemandante = false;
    }
  }

  existeDemandante(demandante: PersonaDto): boolean {
    if (this.isEditarDemandante) {
      return false;
    } else {
      return this.demandantes.some(
        item =>
          item.idTipoIdentificacion === demandante.idTipoIdentificacion &&
          item.identificacion == demandante.identificacion
      );
    }
  }

  borrarDemandante(id: number, tipoPersona: number) {
    this.demandantes.splice(id, 1);
  }

  /** Apoderados */

  addFormApoderado() {
    this.mostrarApoderado = true;
  }

  onSubmitApoderado(form: FormGroup) {
    this.onApoderados = false;
    this.formApoderado = form;
    if (this.validarFormDemandantes() && form?.valid) {
      this.idTipoPersonaSeleccionadoDemandada = Constants.TIPO_PERSONA.NATURAL;
      if (this.isEditarApoderado) {
        this.mostrarTipoPersonaDemandada = false;
        this.mostrarFomularioNaturalDemandada = false;
      } else {
        this.mostrarTipoPersonaDemandada = true;
        this.mostrarFomularioNaturalDemandada = true;
      }
    }

    if (form?.valid) {
      this.formDatosApoderadoValido = true;
    }
  }

  guardarDatosApoderado() {
    this.guardarApoderado(this.formApoderado, true);
  }

  guardarApoderado(form: FormGroup, esProvisional: boolean) {
    const apoderado = this.crearApoderado(form);
    const valido = this.esApoderadoValido(apoderado);
    if (!valido) {
      this.markFormsAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    if (esProvisional) {
      this.mostrarTipoPersonaDemandada = true;
      if (this.isEditarApoderado) {
        this.alertaModalService.confirmacion(
          this.alertaText['asuntos-alertas']['editar-datos'],
          '',
          () => {
            apoderado.id = this.apoderados[this.indiceArrayApoderado].id;
            this.agregarApoderadoEditado(apoderado, esProvisional);
          },
          () => {
            this.limpiarFormApoderado();
            this.isEditarApoderado = false;
            this.alertaModalService.exito(
              this.alertaText['asuntos-alertas']['operacion-cancelada']
            );
          }
        );
      } else {
        this.agregarApoderado(apoderado, esProvisional);
      }
    } else {
      if (this.existePersonaApoderada == false) {
        if (this.isEditarApoderado) {
          apoderado.id = this.apoderados[this.indiceArrayApoderado].id;
          this.agregarApoderadoEditado(apoderado, false);
        } else {
          if (this.existeApoderado(apoderado)) {
            this.alertaModalService.advertencia(
              this.alertaText['asuntos-alertas']['apoderado-ya-agregado']
            );
          } else {
            this.mostrarTipoPersonaDemandada = true;
            this.agregarApoderado(apoderado, false);
          }
        }
      } else {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['sic-comp-desleal-alertas']['existe']
        );
      }
    }
  }

  crearApoderado(form: FormGroup): PersonaDto {
    return {
      idTipoPersona: 1,
      idTipoIdentificacion: +form.get('typeOfDocument')?.value,
      identificacion: form.get('numberOfDocument')?.value,
      primerNombre: form.get('primerNombre')?.value,
      segundoNombre: form.get('segundoNombre')?.value,
      primerApellido: form.get('primerApellido')?.value,
      segundoApellido: form.get('segundoApellido')?.value,
      tarjetaProfesional: form.get('tarjetaProfesional')?.value,
      correoElectronico: form.get('email')?.value,
      telefonoPrincipal: form.get('telefono')?.value,
      municipio: {
        id: form.get('municipality')?.value,
        idDepartamento: form.get('departament')?.value,
      },
      ciudadExtranjero: form.get('otroDepartamentoApoderado')?.value,
      departamentoExtranjero: form.get('otroMunicipioApoderado')?.value,
      direccionPersona: [
        {
          direccionNotificacion: form.get('addressNotificationJudicial')?.value,
        },
      ],
      country: form.get('country')?.value,
    };
  }

  agregarApoderado(apoderado: PersonaDto, esProvisional: boolean): void {
    this.apoderados.push(apoderado);
    this.limpiarFormApoderado();
    this.showTipoDocApoderados();
    this.isEditarApoderado = false;
    if (esProvisional) {
      this.onSubmitCompiladoFormularios(false);
    } else {
      this.alertaModalService.exito(
        this.alertaText['agregado'],
        this.alertaText['asuntos-alertas']['apoderado-agregado']
      );
    }
  }

  limpiarFormApoderado() {
    this.apoderado = this.apoderado.map((field: FormField) => {
      field.value = undefined;
      return field;
    });
    this.formApoderado.reset();
    this.mostrarApoderado = false;
  }

  agregarApoderadoEditado(apoderado: PersonaDto, esProvisional: boolean): void {
    this.apoderados.splice(this.indiceArrayApoderado, 1);
    this.apoderados.push(apoderado);
    this.limpiarFormApoderado();
    this.showTipoDocApoderados();
    this.isEditarApoderado = false;
    if (esProvisional) {
      this.onSubmitCompiladoFormularios(false);
    } else {
      this.alertaModalService.exito(
        this.alertaText['asuntos-alertas']['editado'],
        this.alertaText['asuntos-alertas']['apoderado-editado']
      );
    }
  }

  showTipoDocApoderados() {
    this.dataTableApoderado = this.apoderados;
    this.dataTableApoderado.forEach((elemento: PersonaDto) => {
      if (elemento.modifyNames == undefined || elemento.modifyNames == false) {
        if (elemento.tipoIdentificacion != Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) {
          if (elemento.primerNombre) {
            elemento.primerNombre =
              this.validarContenidoNombres(elemento.primerNombre) +
              ' ' +
              this.validarContenidoNombres(elemento.segundoNombre) +
              ' ' +
              this.validarContenidoNombres(elemento.primerApellido) +
              ' ' +
              this.validarContenidoNombres(elemento.segundoApellido);
          }

          elemento.modifyNames = true;
        }
      }
      if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.CC) {
        elemento.tipoIdentificacion = 'CC';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.CE) {
        elemento.tipoIdentificacion = 'CE';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) {
        elemento.tipoIdentificacion = 'NIT';
        elemento.primerNombre = elemento.razonSocial;
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.PASAPORTE) {
        elemento.tipoIdentificacion = 'Pasaporte';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.TI) {
        elemento.tipoIdentificacion = 'TI';
      }
    });
    this.iniciarColumnasApoderados();
  }

  existeApoderado(apoderado: PersonaDto): boolean {
    return this.apoderados.some(
      item =>
        item.idTipoIdentificacion === apoderado.idTipoIdentificacion &&
        item.identificacion == apoderado.identificacion
    );
  }

  borrarApoderado(id: number) {
    this.apoderados.splice(id, 1);
  }

  validarFormularioApoderado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;

    if (this.isEditarApoderado == false) {
      if (
        $event.controlName == 'numberOfDocument' ||
        $event.controlName == 'typeOfDocument'
      ) {
        if (idTipoDocumento !== null && identificacion !== null) {
          let isEmptyApoderado: boolean = this.searchInApoderado(
            idTipoDocumento,
            identificacion
          );
          let isEmptyDemandado: boolean = this.searchInDemandados(
            idTipoDocumento,
            identificacion
          );
          let isEmptyDemandantes: boolean = this.searchInDemandantes(
            idTipoDocumento,
            identificacion
          );
          if (isEmptyApoderado && isEmptyDemandado && isEmptyDemandantes) {
            this.existePersonaApoderada = false;
            // this.validarUsuario(
            //   idTipoDocumento,
            //   identificacion,
            //   formGroup,
            //   'apoderado'
            // );
          } else if (isEmptyDemandantes == false) {
            this.existePersonaApoderada = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          } else if (isEmptyDemandado == false) {
            this.existePersonaApoderada = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandado']
            );
          } else if (isEmptyApoderado == false) {
            this.existePersonaApoderada = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-apoderado']
            );
          }
        }
      }
    }

    const numeroDocumento = this.apoderado.find(
      field => field.name == 'numberOfDocument'
    );
    const documentNumber = formGroup?.get('numberOfDocument');
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (idTipoDocumento == 4) {
          if (numeroDocumento != undefined) {
            documentNumber?.setValidators([
              Validators.required,
              Validators.minLength(4),
              Validators.maxLength(8),
              Validators.pattern(
                Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
              ),
            ]);
            numeroDocumento.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else {
          if (numeroDocumento != undefined) {
            documentNumber?.setValidators([
              Validators.required,
              Validators.maxLength(12),
              Validators.minLength(4),
              Validators.pattern(Constants.REGEX_TELEFONO),
            ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumento.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }

        formGroup?.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if ($event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamentoApoderado']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioApoderado']?.removeValidators(
          Validators.required
        );
      } else {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryApoderado.push(formGroup?.controls['country'].value);
          if (this.auxIdCountryApoderado.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryApoderado[this.auxIdCountryApoderado.length - 2];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoApoderado'].setValue('');
          formGroup?.controls['otroMunicipioApoderado'].setValue('');
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoApoderado']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoApoderado']?.markAsDirty();
        formGroup?.controls['otroDepartamentoApoderado']?.markAllAsTouched();
        formGroup?.controls['otroMunicipioApoderado']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioApoderado']?.markAsDirty();
        formGroup?.controls['otroMunicipioApoderado']?.markAllAsTouched();
        formGroup?.get('otroMunicipioApoderado')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoApoderado')?.updateValueAndValidity();
        this.apoderado.forEach((field: FormField) => {
          if (
            ['otroMunicipioApoderado', 'otroDepartamentoApoderado'].includes(
              field.name
            )
          ) {
            field.required = true;
          }
        });
      }
    }
  }

  /** Demandados */

  guardarDatosDemandado() {
    if (this.mostrarFomularioNaturalDemandada) {
      this.guardarDemandado(this.formDemandadaNatural, 1, true);
    } else if (this.mostrarFomularioJuridicoDemandada) {
      this.guardarDemandado(this.formDemandadaJuridico, 2, true);
    }
  }

  guardarDemandado(
    form: FormGroup,
    tipoPersona: number,
    esProvisional: boolean
  ) {
    const esNatural: boolean = tipoPersona === Constants.TIPO_PERSONA.NATURAL;
    const demandado = this.crearDemandado(form, esNatural);
    const valido = this.esDemandadoValido(demandado);
    if (!valido) {
      this.markFormsAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    if (esProvisional) {
      if (this.isEditarDemandado) {
        this.alertaModalService.confirmacion(
          this.alertaText['asuntos-alertas']['editar-datos'],
          '',
          () => {
            demandado.id = this.demandados[this.indiceArrayDemandando].id;
            this.agregarDemandadoEditado(demandado, esProvisional);
          },
          () => {
            this.limpiarFormDemandados(demandado);
            this.isEditarDemandado = false;
            this.alertaModalService.exito(
              this.alertaText['asuntos-alertas']['operacion-cancelada']
            );
          }
        );
      } else {
        this.agregarDemandado(demandado, esProvisional);
      }
    } else {
      if (this.existePersonaDemandado == false) {
        if (this.isEditarDemandado) {
          demandado.id = this.demandados[this.indiceArrayDemandando].id;
          this.agregarDemandadoEditado(demandado, false);
        } else {
          if (this.existeDemandado(demandado)) {
            this.alertaModalService.advertencia(
              this.alertaText['demandado-ya-agregado']
            );
          } else {
            this.agregarDemandado(demandado, false);
          }
        }
      } else {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['sic-comp-desleal-alertas']['existe']
        );
      }
    }
  }

  crearDemandado(form: FormGroup, esNatural: boolean): PersonaDto {
    if (esNatural) {
      return {
        idTipoPersona: 1,
        idTipoIdentificacion: +form.get('typeOfDocument')?.value,
        identificacion: form.get('numberOfDocument')?.value,
        primerNombre: form.get('primerNombre')?.value,
        segundoNombre: form.get('segundoNombre')?.value,
        primerApellido: form.get('primerApellido')?.value,
        segundoApellido: form.get('segundoApellido')?.value,
        municipio: {
          id: form.get('municipality')?.value,
          idDepartamento: form.get('departament')?.value,
          idPais: form.get('country')?.value
        },
        ciudadExtranjero: form.get('otroMunicipioDemandadoPN')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandadoPN')?.value,
        direccionPersona: [
          {
            direccionNotificacion: form.get('addressNotificationJudicial')
              ?.value,
          },
        ],
        correoElectronico: form.get('email')?.value,
        country: form.get('country')?.value,
      };
    } else {
      return {
        idTipoPersona: 2,
        idTipoIdentificacion: Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT,
        identificacion: form.get('numberOfDocument')?.value,
        razonSocial: form.get('razonSocial')?.value,
        tipoSociedad: {
          id: form.get('tipoSociedad')?.value,
          valor:
            this.listaTipoSociedad.find(
              element => element.Id === form.get('tipoSociedad')?.value
            )?.Valor || '',
        },
        municipio: {
          id: form.get('municipality')?.value,
          idDepartamento: form.get('departament')?.value,
          idPais: form.get('country')?.value
        },
        ciudadExtranjero: form.get('otroMunicipioDemandadoPJ')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandadoPJ')?.value,
        direccionPersona: [
          {
            direccionNotificacion: form.get('addressNotificationJudicial')
              ?.value,
          },
        ],
        correoElectronico: form.get('email')?.value,
        country: form.get('country')?.value,
        datosRepresentanteLegal: null,
      };
    }
  }

  agregarDemandado(demandado: PersonaDto, esProvisional: boolean): void {
    this.demandados.push(demandado);
    this.limpiarFormDemandados(demandado);
    this.showTipoDocDemandados();
    this.isEditarDemandado = false;
    this.mostrarTipoPersonaDemandada = false;
    if (esProvisional) {
      this.onSubmitCompiladoFormularios(false);
    } else {
      this.alertaModalService.exito(
        this.alertaText['agregado'],
        this.alertaText['demandado-agregado']
      );
    }
  }

  agregarDemandadoEditado(demandado: PersonaDto, esProvisional: boolean) {
    this.demandados.splice(this.indiceArrayDemandando, 1);
    this.demandados.push(demandado);
    this.limpiarFormDemandados(demandado);
    this.showTipoDocDemandados();
    this.isEditarDemandado = false;
    if (esProvisional) {
      this.onSubmitCompiladoFormularios(false);
    } else {
      this.alertaModalService.exito(
        this.alertaText['asuntos-alertas']['editado'],
        this.alertaText['asuntos-alertas']['demandado-editado']
      );
    }
  }

  showTipoDocDemandados() {
    this.dataTableDemandados = this.demandados;
    this.dataTableDemandados.forEach((elemento: PersonaDto) => {
      if (elemento.modifyNames == undefined || elemento.modifyNames == false) {
        if (elemento.tipoIdentificacion != Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) {
          if (elemento.primerNombre) {
            elemento.primerNombre =
              this.validarContenidoNombres(elemento.primerNombre) +
              ' ' +
              this.validarContenidoNombres(elemento.segundoNombre) +
              ' ' +
              this.validarContenidoNombres(elemento.primerApellido) +
              ' ' +
              this.validarContenidoNombres(elemento.segundoApellido);
          }

          elemento.modifyNames = true;
        }
      }
      if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.CC) {
        elemento.tipoIdentificacion = 'CC';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.CE) {
        elemento.tipoIdentificacion = 'CE';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) {
        elemento.tipoIdentificacion = 'NIT';
        elemento.primerNombre = elemento.razonSocial;
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.PASAPORTE) {
        elemento.tipoIdentificacion = 'Pasaporte';
      } else if (elemento.idTipoIdentificacion == Constants.TIPOS_DOCUMENTOS_PERSONAS.TI) {
        elemento.tipoIdentificacion = 'TI';
      }
    });
    this.iniciarColumnasDemandados();
  }

  limpiarFormDemandados(demandado: PersonaDto) {
    this.tipoPersonaDemandanda = this.tipoPersonaDemandanda.map(
      (field: FormField) => {
        field.value = undefined;
        return field;
      }
    );
    this.idTipoPersonaSeleccionadoDemandada = null;
    if (demandado.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      this.mostrarFomularioNaturalDemandada = false;
      this.demandadaPN = this.demandadaPN.map((field: FormField) => {
        field.value = undefined;
        return field;
      });
    } else {
      this.mostrarFomularioJuridicoDemandada = false;
      this.demandadaPJ = this.demandadaPJ.map((field: FormField) => {
        field.value = undefined;
        return field;
      });
    }
  }

  existeDemandado(demandado: PersonaDto): boolean {
    return this.demandados.some(
      item =>
        item.idTipoIdentificacion === demandado.idTipoIdentificacion &&
        item.identificacion === demandado.identificacion
    );
  }

  borrarDemandado(id: number, tipoPersona: number) {
    this.demandados.splice(id, 1);
  }

  onSubmitDemandanda(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName === 'tipoPersonaDemandada') {
      this.idTipoPersonaSeleccionadoDemandada = event.form.get(
        event.controlName
      )?.value;
    }
    if (this.idTipoPersonaSeleccionadoDemandada == 1) {
      this.mostrarFomularioNaturalDemandada = true;
      this.mostrarFomularioJuridicoDemandada = false;
    } else if (this.idTipoPersonaSeleccionadoDemandada == 2) {
      this.mostrarFomularioNaturalDemandada = false;
      this.mostrarFomularioJuridicoDemandada = true;
    } else {
      this.mostrarFomularioNaturalDemandada = false;
      this.mostrarFomularioJuridicoDemandada = false;
      event.form?.reset();
    }

    if (event.form?.valid) {
      this.formTipoPersonaValidoDemandada = true;
    }
  }

  // Función que maneja el evento del formulario de demandanda PJ
  onSubmitDatosDemandadaPN(form: FormGroup) {
    this.onDemandados = false;
    this.formDemandadaNatural = form;
    if (this.formTipoPersonaValidoDemandada && form?.valid) {
    }

    if (form?.valid) {
      this.formDatosDemandadaPnValido = true;
    }
  }

  // Función que maneja el evento del formulario de demandanda PJ
  onSubmitDatosDemandadaPJ(form: FormGroup) {
    this.onDemandados = false;
    this.formDemandadaJuridico = form;
    if (this.formTipoPersonaValidoDemandada && form?.valid) {
    }

    if (form?.valid) {
      this.formDatosDemandadaPjValido = true;
    }
  }

  validarFormularioDemandadaN($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    this.demandadoAux = formGroup?.value;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    if (this.isEditarDemandado == false) {
      if (
        $event.controlName == 'numberOfDocument' ||
        $event.controlName == 'typeOfDocument'
      ) {
        if (idTipoDocumento !== null && identificacion !== null) {
          let isEmptyApoderado: boolean = this.searchInApoderado(
            idTipoDocumento,
            identificacion
          );
          let isEmptyDemandado: boolean = this.searchInDemandados(
            idTipoDocumento,
            identificacion
          );
          let isEmptyDemandantes: boolean = this.searchInDemandantes(
            idTipoDocumento,
            identificacion
          );
          if (isEmptyApoderado && isEmptyDemandado && isEmptyDemandantes) {
            this.existePersonaDemandado = false;
            // this.validarUsuario(
            //   idTipoDocumento,
            //   identificacion,
            //   formGroup,
            //   'demandado'
            // );
          } else if (isEmptyDemandantes == false) {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          } else if (isEmptyDemandado == false) {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandado']
            );
          } else if (isEmptyApoderado == false) {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-apoderado']
            );
          }
        }
      }
    }

    const numeroDocumentoDemandandanteN = this.demandadaPN.find(
      field => field.name == 'numberOfDocument'
    );
    if ($event.controlName == 'typeOfDocument') {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5) {
          if (numeroDocumentoDemandandanteN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandandanteN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }
        formGroup?.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if ($event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamentoDemandadoPN']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandadoPN']?.removeValidators(
          Validators.required
        );
      } else {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandado.push(formGroup?.controls['country'].value);
          if (this.auxIdCountryDemandado.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandado[this.auxIdCountryDemandado.length - 2];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandadoPN'].setValue('');
          formGroup?.controls['otroMunicipioDemandadoPN'].setValue('');
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandadoPN']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandadoPN']?.markAsDirty();
        formGroup?.controls['otroDepartamentoDemandadoPN']?.markAllAsTouched();
        formGroup?.controls['otroMunicipioDemandadoPN']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandadoPN']?.markAsDirty();
        formGroup?.controls['otroMunicipioDemandadoPN']?.markAllAsTouched();
        formGroup?.get('otroMunicipioDemandadoPN')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoDemandadoPN')?.updateValueAndValidity();
        this.demandadaPN.forEach((field: FormField) => {
          if (
            [
              'otroMunicipioDemandadoPN',
              'otroDepartamentoDemandadoPN',
            ].includes(field.name)
          ) {
            field.required = true;
          }
        });
      }
    }
  }

  validarFormularioDemandadaJ($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    this.demandadoAux = formGroup?.value;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    if (this.isEditarDemandado == false) {
      if ($event.controlName == 'numberOfDocument') {
        if (identificacion !== null) {
          let isEmptyApoderado: boolean = this.searchInApoderado(
            3,
            identificacion
          );
          let isEmptyDemandado: boolean = this.searchInDemandados(
            3,
            identificacion
          );
          let isEmptyDemandantes: boolean = this.searchInDemandantes(
            3,
            identificacion
          );
          if (isEmptyApoderado && isEmptyDemandado && isEmptyDemandantes) {
            this.existePersonaDemandado = false;
            // this.validarUsuario(3, identificacion, formGroup, 'demandado');
          } else if (isEmptyDemandantes == false) {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          } else if (isEmptyDemandado == false) {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandado']
            );
          } else if (isEmptyApoderado == false) {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-apoderado']
            );
          }
        }
      }
    }
    if ($event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamentoDemandadoPJ']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandadoPJ']?.removeValidators(
          Validators.required
        );
      } else {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandado.push(formGroup?.controls['country'].value);
          if (this.auxIdCountryDemandado.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandado[this.auxIdCountryDemandado.length - 2];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandadoPJ'].setValue('');
          formGroup?.controls['otroMunicipioDemandadoPJ'].setValue('');
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandadoPJ']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamentoDemandadoPJ']?.markAsDirty();
        formGroup?.controls['otroDepartamentoDemandadoPJ']?.markAllAsTouched();
        formGroup?.controls['otroMunicipioDemandadoPJ']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandadoPJ']?.markAsDirty();
        formGroup?.controls['otroMunicipioDemandadoPJ']?.markAllAsTouched();
        formGroup?.get('otroMunicipioDemandadoPJ')?.updateValueAndValidity();
        formGroup?.get('otroDepartamentoDemandadoPJ')?.updateValueAndValidity();
        this.demandadaPJ.forEach((field: FormField) => {
          if (
            [
              'otroMunicipioDemandadoPJ',
              'otroDepartamentoDemandadoPJ',
            ].includes(field.name)
          ) {
            field.required = true;
          }
        });
      }
    }
  }

  /** Busqueda personas guardadas */
  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: string
  ): boolean {
    let isEmpty: boolean = true;
    let i: number = 0;
    while (i < this.demandantes.length) {
      const elemento = this.demandantes[i];
      if (elemento.idTipoIdentificacion === idTipoDocumento) {
        if (elemento.identificacion == identificacion) {
          isEmpty = false;
          break;
        } else {
          isEmpty = true;
        }
      }
      i++;
    }
    return isEmpty;
  }

  searchInApoderado(idTipoDocumento: number, identificacion: string): boolean {
    let isEmpty: boolean = true;
    let i: number = 0;
    while (i < this.apoderados.length) {
      const elemento = this.apoderados[i];
      if (elemento.idTipoIdentificacion === idTipoDocumento) {
        if (elemento.identificacion == identificacion) {
          isEmpty = false;
          break;
        } else {
          isEmpty = true;
        }
      }
      i++;
    }
    return isEmpty;
  }

  searchInDemandados(idTipoDocumento: number, identificacion: string): boolean {
    let isEmpty: boolean = true;
    let i: number = 0;
    while (i < this.demandados.length) {
      const elemento = this.demandados[i];
      if (elemento.idTipoIdentificacion === idTipoDocumento) {
        if (elemento.identificacion === identificacion) {
          isEmpty = false;
          break;
        } else {
          isEmpty = true;
        }
      }
      i++;
    }
    return isEmpty;
  }

  validarUsuario(
    tipo: number,
    numero: string,
    form: FormGroup,
    tipoPersona: string
  ) {
    this.servicePersona
      .persona(tipo, numero)
      .subscribe((resp: PersonaConsultadaDTO) => {
        if (resp != null && resp) {
          if (tipoPersona == 'apoderado') {
            this.setearFormApoderado(resp);
          } else if (tipoPersona == 'demandante') {
            this.seteatFormDemandante(resp);
          } else {
            this.seteatFormDemandado(resp, form);
          }
        } else {
          /*
          if (tipoPersona == 'apoderado') {
            this.formApoderado.patchValue({
              tipoPersona: '',
              primerNombre: '',
              segundoNombre: '',
              primerApellido: '',
              segundoApellido: '',
              tarjetaProfesional: '',
              email: '',
              telefono: '',
              country: '',
              departament: '',
              municipality: '',
              addressNotificationJudicial: '',
            });
          } else if (tipoPersona == 'demandante') {
            if (
              this.idTipoPersonaSeleccionadoDemandante ==
              Constants.TIPO_PERSONA.NATURAL
            ) {
              this.formDemandanteNatural.patchValue({
                primerNombre: '',
                segundoNombre: '',
                primerApellido: '',
                segundoApellido: '',
                genero: '',
                fechaNacimiento: '',
                nacionalidadPerson: '',
                nacionalidadDouble: '',
                country: '',
                departament: '',
                municipality: '',
                direccionPersona: '',
                addressNotificationJudicial: '',
                telefono: '',
                fax: '',
                apartadoAereo: '',
                email: '',
                paginaWeb: '',
              });
            } else {
              this.formDemandanteJuridico.patchValue({
                razonSocial: '',
                tipoSociedad: '',
                country: '',
                departament: '',
                municipality: '',
                addressNotificationJudicial: '',
                telefono: '',
                fax: '',
                apartadoAereo: '',
                email: '',
                paginaWeb: '',
                primerNombreRl: '',
                segundoNombreRl: '',
                primerApellidoRl: '',
                segundoApellidoRl: '',
                genero: '',
                fechaNacimiento: '',
                typeOfDocumentRl: '',
                numberOfDocumentRl: '',
                emailRl: '',
                nacionalidadPerson: '',
                nacionalidadDouble: '',
                countryRl: '',
                departamentRl: '',
                municipalityRl: '',
                direccionPersona: '',
                addressNotificationJudicialRl: '',
                phoneRl: '',
                faxRl: '',
                apartadoAereoRl: '',
                emailNotificacionRl: '',
              });
            }
          } else {
            if (
              this.idTipoPersonaSeleccionadoDemandada ==
              Constants.TIPO_PERSONA.NATURAL
            ) {
              const currentTypeOfDocument =
                this.formDemandadaNatural.get('typeOfDocument')?.value;
              const currentNumberOfDocument =
                this.formDemandadaNatural.get('numberOfDocument')?.value;
              this.formDemandadaNatural.patchValue({
                tipoPersonaDemandada: '',
                email: '',
                primerNombre: '',
                segundoNombre: '',
                primerApellido: '',
                segundoApellido: '',
                country: '',
                departament: '',
                municipality: '',
                addressNotificationJudicial: '',
              });
            } else {
              const currentNumberOfDocument =
                this.formDemandadaJuridico.get('numberOfDocument')?.value;
              this.formDemandadaJuridico.patchValue({
                tipoPersonaDemandada: '',
                email: '',
                razonSocial: '',
                tipoSociedad: '',
                country: '',
                departament: '',
                municipality: '',
                addressNotificationJudicial: '',
              });
            }
          }
          */
        }
      });
  }

  setearFormApoderado(response: PersonaConsultadaDTO) {
    response = this.textTransformService.transformarAMayusculas(response);
    this.apoderado = this.apoderado.map((field: FormField) => {
      switch (field.name) {
        case 'typeOfDocument':
          field.value = response.Id_Tipo_Identificacion;
          break;
        case 'numberOfDocument':
          field.value = response.Identificacion;
          break;
        case 'primerNombre':
          field.value = response.Persona_Natural[0].Primer_nombre;
          break;
        case 'segundoNombre':
          field.value = response.Persona_Natural[0].Segundo_nombre;
          break;
        case 'primerApellido':
          field.value = response.Persona_Natural[0].Primer_apellido;
          break;
        case 'segundoApellido':
          field.value = response.Persona_Natural[0].Segundo_apellido;
          break;
        case 'addressNotificationJudicial':
          field.value =
            response.Direccion_Persona.find(
              (elemento: {
                Direccion_Notificacion?: string;
                Es_Primaria?: boolean;
                Id?: number;
              }) => elemento.Es_Primaria
            )?.Direccion_Notificacion ?? '';
          break;
        case 'country':
          field.value = response.Municipio.Departamento.Pais.Id;
          break;
        case 'departament':
          field.value = response.Municipio.Departamento.Id;
          break;
        case 'municipality':
          field.value = response.Municipio.Id;
          break;
        case 'tarjetaProfesional':
          field.value = response.Tarjeta_profesional;
          break;
        case 'email':
          field.value = response.Correo_electronico;
          break;
      }
      return field;
    });
  }

  seteatFormDemandante(response: PersonaConsultadaDTO) {
    response = this.textTransformService.transformarAMayusculas(response);
    if (response.Id_Tipo_Persona == Constants.TIPO_PERSONA.NATURAL) {
      const tipoPersona: PersonaNaturalDTO = {
        tipoPersonaDemandante: response.Id_Tipo_Persona,
        country: 0,
        departament: 0,
        municipality: 0,
      };
      const personaNatural: PersonaNaturalDTO = {
        typeOfDocument: response.Id_Tipo_Identificacion,
        numberOfDocument: response.Identificacion,
        primerNombre: response.Persona_Natural[0].Primer_nombre,
        segundoNombre: response.Persona_Natural[0].Segundo_nombre,
        primerApellido: response.Persona_Natural[0].Primer_apellido,
        segundoApellido: response.Persona_Natural[0].Segundo_apellido,
        emailNotificationJudicial: response.Correo_electronico,
        country: response.Municipio.Departamento.Pais.Id,
        departament: response.Municipio.Departamento.Id,
        municipality: response.Municipio.Id,
        direccionPersona:
          response.Direccion_Persona.find(
            (elemento: {
              Direccion_Notificacion?: string;
              Es_Primaria?: boolean;
              Id?: number;
            }) => elemento.Es_Primaria
          )?.Direccion_Notificacion ?? '',
        addressNotificationJudicial:
          response.Direccion_Persona.find(
            (elemento: {
              Direccion_Notificacion?: string;
              Es_Primaria?: boolean;
              Id?: number;
            }) => elemento.Es_Primaria
          )?.Direccion_Notificacion ?? '',
      };

      this.tipoPersonaDemandante = this.tipoPersonaDemandante.map(field => {
        if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
          field.value = tipoPersona[field.name as keyof typeof tipoPersona];
        }
        return field;
      });
      this.demandantePN = this.demandantePN.map(field => {
        if (
          personaNatural[field.name as keyof typeof personaNatural] !==
          undefined
        ) {
          field.value =
            personaNatural[field.name as keyof typeof personaNatural];
        }
        return field;
      });
    } else {
      const tipoPersona: PersonaJuridicaDTO = {
        tipoPersonaDemandante: response.Id_Tipo_Persona,
        country: 0,
        departament: 0,
        municipality: 0,
      };
      const personaJuridica: PersonaJuridicaDTO = {
        typeOfDocument: response?.Id_Tipo_Identificacion,
        numberOfDocument: response.Identificacion,
        razonSocial:
          response.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0]
            .Razon_Social,
        country: response.Municipio.Departamento.Pais.Id,
        departament: response.Municipio.Departamento.Id,
        municipality: response.Municipio.Id,
        addressNotificationJudicial:
          response.Direccion_Persona.find(
            (elemento: {
              Direccion_Notificacion?: string;
              Es_Primaria?: boolean;
              Id?: number;
            }) => elemento.Es_Primaria
          )?.Direccion_Notificacion ?? '',
        email: response.Correo_electronico,
      };
      this.tipoPersonaDemandante = this.tipoPersonaDemandante.map(field => {
        if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
          field.value = tipoPersona[field.name as keyof typeof tipoPersona];
        }
        return field;
      });
      this.demandantePJ = this.demandantePJ.map(field => {
        if (
          personaJuridica[field.name as keyof typeof personaJuridica] !==
          undefined
        ) {
          field.value =
            personaJuridica[field.name as keyof typeof personaJuridica];
        }
        return field;
      });
    }
  }

  seteatFormDemandado(response: PersonaConsultadaDTO, form: FormGroup) {
    response = this.textTransformService.transformarAMayusculas(response);
    if (response.Id_Tipo_Persona == Constants.TIPO_PERSONA.NATURAL) {
      const tipoPersona: PersonaNaturalDTO = {
        tipoPersonaDemandado: response.Id_Tipo_Persona,
        country: 0,
        departament: 0,
        municipality: 0,
      };
      const personaNatural: PersonaNaturalDTO = {
        typeOfDocument: response.Id_Tipo_Identificacion,
        numberOfDocument: response.Identificacion,
        primerNombre: response.Persona_Natural[0].Primer_nombre,
        segundoNombre: response.Persona_Natural[0].Segundo_nombre,
        primerApellido: response.Persona_Natural[0].Primer_apellido,
        segundoApellido: response.Persona_Natural[0].Segundo_apellido,
        email: response.Correo_electronico,
        country: response.Municipio.Departamento.Pais.Id,
        departament: response.Municipio.Departamento.Id,
        municipality: response.Municipio.Id,
        addressNotificationJudicial:
          response.Direccion_Persona.find(
            (elemento: {
              Direccion_Notificacion?: string;
              Es_Primaria?: boolean;
              Id?: number;
            }) => elemento.Es_Primaria
          )?.Direccion_Notificacion ?? '',
      };
      this.tipoPersonaDemandanda = this.tipoPersonaDemandanda.map(field => {
        if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
          field.value = tipoPersona[field.name as keyof typeof tipoPersona];
        }
        return field;
      });
      this.demandadaPN = this.demandadaPN.map(field => {
        if (
          personaNatural[field.name as keyof typeof personaNatural] !==
          undefined
        ) {
          field.value =
            personaNatural[field.name as keyof typeof personaNatural];
        }
        return field;
      });
    } else {
      const tipoPersona: PersonaNaturalDTO = {
        tipoPersonaDemandado: response.Id_Tipo_Persona,
        country: 0,
        departament: 0,
        municipality: 0,
      };
      const personaJuridica: PersonaJuridicaDTO = {
        typeOfDocument: response?.Id_Tipo_Identificacion,
        numberOfDocument: response?.Identificacion,
        razonSocial:
          response.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0]
            .Razon_Social,
        country: response?.Municipio?.Departamento?.Pais?.Id,
        departament: response?.Municipio?.Departamento?.Id,
        municipality: response?.Municipio?.Id,
        addressNotificationJudicial:
          response.Direccion_Persona.find(
            (elemento: {
              Direccion_Notificacion?: string;
              Es_Primaria?: boolean;
              Id?: number;
            }) => elemento.Es_Primaria
          )?.Direccion_Notificacion ?? '',
        email: response.Correo_electronico,
      };
      this.tipoPersonaDemandanda = this.tipoPersonaDemandanda.map(field => {
        if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
          field.value = tipoPersona[field.name as keyof typeof tipoPersona];
        }
        return field;
      });
      this.demandadaPJ = this.demandadaPJ.map(field => {
        if (
          personaJuridica[field.name as keyof typeof personaJuridica] !==
          undefined
        ) {
          field.value =
            personaJuridica[field.name as keyof typeof personaJuridica];
        }
        return field;
      });
    }
  }

  validarContenidoNombres(valor: string | undefined): string {
    if (typeof valor === 'string' && valor.trim().length > 0) {
      return valor;
    }
    return '';
  }

  // tablas
  private iniciarColumnasDemandantes() {
    this.columnsDemandantes = [
      {
        field: 'tipoIdentificacion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerNombre',
        title: this.asuntosText['asuntos-mercantiles']['nombre-razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: 'editar',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: 'eliminar',
      },
    ];
  }

  private iniciarColumnasApoderados() {
    this.columnsApoderados = [
      {
        field: 'tipoIdentificacion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'tarjetaProfesional',
        title: this.comunText['tarjeta-profesional'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerNombre',
        title: this.asuntosText['asuntos-mercantiles']['nombre-razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: 'editar',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: 'eliminar',
      },
    ];
  }

  private iniciarColumnasDemandados() {
    this.columnsDemandados = [
      {
        field: 'tipoIdentificacion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerNombre',
        title: this.asuntosText['asuntos-mercantiles']['nombre-razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: 'editar',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: 'eliminar',
      },
    ];
  }

  addDemandante(sectionId: string) {
    this.isEditarDemandante = false;
    this.scrollToSection(sectionId);
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    switch (sectionId) {
      case 'demandantes':
        this.mostrarTipoPersonaDemandante = true;
        break;
      case 'apoderados':
        this.mostrarApoderado = true;
        break;
      case 'demandandos':
        this.mostrarTipoPersonaDemandada = true;
        break;
    }
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (sectionId == 'apoderados') {
      this.mostrarApoderado = true;
    }
  }

  acciones(event: any, tipoPersona: string) {
    const persona = event.item as PersonaDto;

    if (event.idAccion == 'editar') {
      if (tipoPersona == 'demandante') {
        this.isEditarDemandante = true;
        this.scrollToSection('demandantes');
        this.setearFormDemandante(persona, event.index);
      } else if (tipoPersona == 'apoderado') {
        this.isEditarApoderado = true;
        this.scrollToSection('apoderados');
        this.setearApoderado(persona, event.index);
      } else if (tipoPersona == 'demandado') {
        this.isEditarDemandado = true;
        this.scrollToSection('demandandos');
        this.setearFormDemandado(persona, event.index);
      }
    } else {
      if (tipoPersona == 'demandante') {
        this.borrarDemandanteTable(persona);
      } else if (tipoPersona == 'apoderado') {
        this.borrarApoderadoTable(persona);
      } else if (tipoPersona == 'demandado') {
        this.borrarDemandadoTable(persona);
      }
    }
  }

  borrarDemandanteTable(persona: PersonaDto) {
    this.demandantes = this.demandantes.filter(item => item !== persona);

    this.dataTableDemandantes = this.demandantes;

    this.iniciarColumnasDemandantes();
  }

  borrarApoderadoTable(persona: PersonaDto) {
    this.apoderados = this.apoderados.filter(item => item !== persona);

    this.dataTableApoderado = this.apoderados;

    this.iniciarColumnasApoderados();
  }

  borrarDemandadoTable(persona: PersonaDto) {
    this.demandados = this.demandados.filter(item => item !== persona);

    this.dataTableDemandados = this.demandados;

    this.iniciarColumnasDemandados();
  }

  setearFormDemandante(persona: PersonaDto, indice: number) {
    this.indiceArrayDemandante = indice;
    this.idTipoPersonaSeleccionadoDemandante = persona.idTipoPersona!;
    const tipoPersona: PersonaNaturalDTO = {
      tipoPersonaDemandante: persona.idTipoPersona!,
      country: 0,
      departament: 0,
      municipality: 0,
    };
    this.tipoPersonaDemandante = this.tipoPersonaDemandante.map(field => {
      if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
        field.value = tipoPersona[field.name as keyof typeof tipoPersona];
      }
      return field;
    });
    if (persona.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      setTimeout(() => {
        this.demandantePN = this.demandantePN.map(field => {
          switch (field.name) {
            case 'primerNombre':
              field.value = this.obtenerPrimerNombre(persona.primerNombre);
              break;
            case 'segundoNombre':
              field.value = persona.segundoNombre;
              break;
            case 'primerApellido':
              field.value = persona.primerApellido;
              break;
            case 'segundoApellido':
              field.value = persona.segundoApellido;
              break;
            case 'genero':
              field.value = persona.idSexo;
              break;
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'fechaNacimiento':
              if (persona.fechaNacimiento) {
                field.value = persona.fechaNacimiento;
              } else {
                field.value = undefined;
              }
              break;
            case 'nacionalidadPerson':
              field.value = persona.nacionalidad;
              break;
            case 'nacionalidadDouble':
              field.value = persona.nacionalidadDoble;
              break;
            case 'country':
              field.value = persona.country;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandantePN':
              field.value = persona.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipioDemandantePN':
              field.value = persona.ciudadExtranjero ?? '';
              break;
            case 'direccionPersona':
              let direccionDomicilio: string = '';
              persona.direccionPersona?.forEach(
                (direccionPersona: DireccionPersonaDto) => {
                  if (direccionPersona.esPrimaria == false) {
                    direccionDomicilio =
                      direccionPersona.direccionNotificacion!;
                  }
                }
              );
              field.value = direccionDomicilio;
              break;
            case 'addressNotificationJudicial':
              let direccionNotificacion: string = '';
              persona.direccionPersona?.forEach(
                (direccionPersona: DireccionPersonaDto) => {
                  if (direccionPersona.esPrimaria) {
                    direccionNotificacion =
                      direccionPersona.direccionNotificacion!;
                  }
                }
              );
              field.value = direccionNotificacion;
              break;
            case 'telefono':
              field.value = persona.telefonoPrincipal;
              break;
            case 'fax':
              field.value = persona.fax;
              break;
            case 'apartadoAereo':
              field.value = persona.apartadoAereo;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
            case 'paginaWeb':
              field.value = persona.paginaWeb;
              break;
          }
          return field;
        });
      }, 800);
    } else {
      // this.mostrarFomularioJuridicoDemandante = true;
      setTimeout(() => {
        this.demandantePJ = this.demandantePJ.map(field => {
          switch (field.name) {
            case 'razonSocial':
              field.value = persona.razonSocial;
              break;
            case 'tipoSociedad':
              if (
                typeof persona.tipoSociedad === 'object' &&
                persona.tipoSociedad !== null
              ) {
                field.value = persona.tipoSociedad.id;
              } else if (typeof persona.tipoSociedad === 'number') {
                field.value = persona.tipoSociedad;
              } else {
                field.value = undefined;
              }
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'country':
              field.value = persona.country;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandantePJ':
              field.value = persona.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipioDemandantePJ':
              field.value = persona.ciudadExtranjero ?? '';
              break;
            case 'addressNotificationJudicial':
              field.value = persona.direccionPersona?.[0].direccionNotificacion;
              break;
            case 'telefono':
              field.value = persona.telefonoPrincipal;
              break;
            case 'fax':
              field.value = persona.fax;
              break;
            case 'apartadoAereo':
              field.value = persona.apartadoAereo;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
            case 'paginaWeb':
              field.value = persona.paginaWeb;
              break;
            case 'primerNombreRl':
              field.value = persona.datosRepresentanteLegal?.primerNombre;
              break;
            case 'segundoNombreRl':
              field.value = persona.datosRepresentanteLegal?.segundoNombre;
              break;
            case 'primerApellidoRl':
              field.value = persona.datosRepresentanteLegal?.primerApellido;
              break;
            case 'segundoApellidoRl':
              field.value = persona.datosRepresentanteLegal?.segundoApellido;
              break;
            case 'genero':
              field.value = persona.datosRepresentanteLegal?.idSexo;
              break;
            case 'fechaNacimiento':
              if (persona.datosRepresentanteLegal?.fechaNacimiento) {
                field.value = persona.datosRepresentanteLegal?.fechaNacimiento;
              } else {
                field.value = undefined;
              }
              break;
            case 'typeOfDocumentRl':
              field.value =
                persona.datosRepresentanteLegal?.idTipoIdentificacion;
              break;
            case 'numberOfDocumentRl':
              field.value = persona.datosRepresentanteLegal?.identificacion;
              break;
            case 'emailRl':
              field.value = persona.datosRepresentanteLegal?.correoElectronico;
              break;
            case 'nacionalidadPerson':
              field.value = persona.datosRepresentanteLegal?.nacionalidad;
              break;
            case 'nacionalidadDouble':
              field.value = persona.datosRepresentanteLegal?.nacionalidadDoble;
              break;
            case 'countryRl':
              field.value = persona.datosRepresentanteLegal?.countryRl;
              break;
            case 'departamentRl':
              field.value =
                persona.datosRepresentanteLegal?.municipio?.idDepartamento;
              break;
            case 'municipalityRl':
              field.value = persona.datosRepresentanteLegal?.municipio?.id;
              break;
            case 'otroDepartamentoRL':
              field.value =
                persona.datosRepresentanteLegal?.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipioRL':
              field.value =
                persona.datosRepresentanteLegal?.ciudadExtranjero ?? '';
              break;
            case 'direccionPersona':
              let direccionDomicilio: string = '';
              persona.datosRepresentanteLegal?.direccionPersona?.forEach(
                (direccionPersona: DireccionPersonaDto) => {
                  if (direccionPersona.esPrimaria == false) {
                    direccionDomicilio =
                      direccionPersona.direccionNotificacion!;
                  }
                }
              );

              field.value = direccionDomicilio;
              break;
            case 'addressNotificationJudicialRl':
              let direccionNotificacion: string = '';
              persona.datosRepresentanteLegal?.direccionPersona?.forEach(
                (direccionPersona: DireccionPersonaDto) => {
                  if (direccionPersona.esPrimaria) {
                    direccionNotificacion =
                      direccionPersona.direccionNotificacion!;
                  }
                }
              );

              field.value = direccionNotificacion;
              break;
            case 'telefonoRl':
              field.value = persona.datosRepresentanteLegal?.telefonoPrincipal;
              break;
            case 'faxRl':
              field.value = persona.datosRepresentanteLegal?.fax;
              break;
            case 'apartadoAereoRl':
              field.value = persona.datosRepresentanteLegal?.apartadoAereo;
              break;
            case 'emailNotificacionRl':
              field.value =
                persona.datosRepresentanteLegal?.correoElectronicoSecundario;
              break;
          }
          return field;
        });
      }, 800);
    }
  }

  setearApoderado(persona: PersonaDto, indice: number) {
    this.indiceArrayApoderado = indice;
    setTimeout(() => {
      this.apoderado = this.apoderado.map(field => {
        switch (field.name) {
          case 'primerNombre':
            field.value = this.obtenerPrimerNombre(persona.primerNombre);
            break;
          case 'segundoNombre':
            field.value = persona.segundoNombre;
            break;
          case 'primerApellido':
            field.value = persona.primerApellido;
            break;
          case 'segundoApellido':
            field.value = persona.segundoApellido;
            break;
          case 'typeOfDocument':
            field.value = persona.idTipoIdentificacion;
            break;
          case 'numberOfDocument':
            field.value = persona.identificacion;
            break;
          case 'tarjetaProfesional':
            field.value = persona.tarjetaProfesional;
            break;
          case 'email':
            field.value = persona.correoElectronico;
            break;
          case 'telefono':
            field.value = persona.telefonoPrincipal;
            break;
          case 'country':
            field.value = persona.country;
            break;
          case 'departament':
            field.value = persona.municipio?.idDepartamento;
            break;
          case 'municipality':
            field.value = persona.municipio?.id;
            break;
          case 'otroDepartamentoApoderado':
            field.value = persona.departamentoExtranjero ?? '';
            break;
          case 'otroMunicipioApoderado':
            field.value = persona.ciudadExtranjero ?? '';
            break;
          case 'addressNotificationJudicial':
            field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
            break;
        }
        return field;
      });
    }, 800);
  }

  setearFormDemandado(persona: PersonaDto, indice: number) {
    this.indiceArrayDemandando = indice;
    this.idTipoPersonaSeleccionadoDemandada = persona.idTipoPersona!;
    const tipoPersona: PersonaNaturalDTO = {
      tipoPersonaDemandada: persona.idTipoPersona!,
      country: 0,
      departament: 0,
      municipality: 0,
    };
    this.tipoPersonaDemandanda = this.tipoPersonaDemandanda.map(field => {
      if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
        field.value = tipoPersona[field.name as keyof typeof tipoPersona];
      }
      return field;
    });
    if (persona.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      setTimeout(() => {
        this.demandadaPN = this.demandadaPN.map(field => {
          switch (field.name) {
            case 'email':
              field.value = persona.correoElectronico;
              break;
            case 'primerNombre':
              field.value = this.obtenerPrimerNombre(persona.primerNombre);
              break;
            case 'segundoNombre':
              field.value = persona.segundoNombre;
              break;
            case 'primerApellido':
              field.value = persona.primerApellido;
              break;
            case 'segundoApellido':
              field.value = persona.segundoApellido;
              break;
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'country':
              field.value = persona.country;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandadoPN':
              field.value = persona.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipioDemandadoPN':
              field.value = persona.ciudadExtranjero ?? '';
              break;
            case 'addressNotificationJudicial':
              field.value =
                persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
          }
          return field;
        });
      }, 800);
    } else {
      setTimeout(() => {
        this.demandadaPJ = this.demandadaPJ.map(field => {
          switch (field.name) {
            case 'email':
              field.value = persona.correoElectronico;
              break;
            case 'razonSocial':
              field.value = persona.razonSocial;
              break;
            case 'tipoSociedad':
              if (
                typeof persona.tipoSociedad === 'object' &&
                persona.tipoSociedad !== null
              ) {
                field.value = persona.tipoSociedad.id;
              } else if (typeof persona.tipoSociedad === 'number') {
                field.value = persona.tipoSociedad;
              } else {
                field.value = undefined;
              }
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'country':
              field.value = persona.country;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandadoPJ':
              field.value = persona.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipioDemandadoPJ':
              field.value = persona.ciudadExtranjero ?? '';
              break;
            case 'addressNotificationJudicial':
              field.value =
                persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
          }
          return field;
        });
      }, 800);
    }
  }

  obtenerPrimerNombre(texto: string | undefined): string {
    if (!texto || typeof texto !== 'string') {
      return '';
    }

    const palabras = texto.trim().split(' ');
    return palabras[0] || '';
  }

  // Documentos
  subirArchivo(subio: any) {
    this.enviarDocumentos = false;
    if (subio) {
    }
  }

  isEmptyAnexo(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    if (requeridosFull == cantidadRequeridos) {
      return true;
    } else {
      return false;
    }
  }

  validarDocumentosObligatorios(): boolean {
    let checkAnexos: boolean = false;
    let formulario: boolean = false;
    const anexosRequeridosIds = this.anexosTramiteObligatorios.map(
      (anexo: any) => anexo.id
    );
    checkAnexos = this.isEmptyAnexo(this.archivosCargados, anexosRequeridosIds);
    formulario = this.validacionFormularios();
    if (checkAnexos && formulario) {
      return true;
    } else {
      return false;
    }
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    this.archivosCargados = archivos;
    const totalBytes = archivos.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);
  }

  // Metodo que valida que todos los formularios de la pagina sean validos
  validacionFormularios(): boolean {
    return (
      this.formAsuntoValido &&
      this.demandantes.length > 0 &&
      this.apoderados.length > 0 &&
      this.demandados.length > 0
    );
  }

  validacionAsunto(): boolean {
    return !this.formAsuntoValido;
  }

  // Envio formulario
  async onSubmitCompiladoFormularios(esEnviar: boolean) {
    if (esEnviar) {
      if (!this.validarActoresCompletos()) {
        this.markFormsAsTouched();
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        return;
      }
      if (!this.validarDocumentosObligatorios()) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['archivos_obligatorios']
        );
        return;
      }
      if (!this.confirmacionEnvio) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['ley_2213']
        );
        return;
      }
      if (!this.seleccionAceptoRechazoEnvio) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['envio_demanda']
        );
        return;
      }
    }
    this.enviarEntidad = esEnviar;

    let tramite = this.buildFormTramite(esEnviar);
    const body = {
      ...tramite,
      enviarCorreoDemandado: this.enviarCorreoDemandado ?? false
    };
    this.serviceMercantiles.crearTramiteSSM(body).subscribe(
      async response => {
        if (response.success) {
          this.idTramite = response.data?.Id!;
          this.idTramiteAsuntosMercantiles = response.data?.Id!;
          if (esEnviar) {
            this.enviarDocumentos = true;
            this.alertaModalService
              .exito(
                this.alertaText['proceso-enviado'],
                this.alertaText['asuntos-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad),
              )
              .then(() => {
                this.router.navigate(['/expediente']);
              });
          } else {
            this.enviarDocumentos = true;
            this.alertaModalService.exito(
              this.alertaText['solicitud-pendiente-finalizar'],
              this.alertaText['asuntos-alertas']['tramite-guardado-mensaje'].replace('{{proceso}}', this.entidad),
            );
            await this.consultarTramitePorID(response.data?.Id!, false);
          }
        }
      },
      err => {
        console.error(err);
      }
    );
  }

  obtenerPrimerNombreByArray(array: PersonaDto[]): PersonaDto[] {
    array.forEach((elemento: PersonaDto) => {
      elemento.primerNombre = this.obtenerPrimerNombre(elemento.primerNombre);
    });
    return array;
  }

  async callServiceCrearTramite(): Promise<{
    success: boolean;
    message?: string;
  }> {
    try {
      if (this.idTipoPersonaSeleccionadoDemandante) {
        if (this.idTipoPersonaSeleccionadoDemandante == 1) {
          if (this.formDemandanteNatural != undefined) {
            this.guardarDemandante(this.formDemandanteNatural, 1, false);
          }
        } else {
          if (this.formDemandanteJuridico != undefined) {
            this.guardarDemandante(this.formDemandanteJuridico, 2, false);
          }
        }
      }
      if (this.formApoderado != undefined && this.formDatosApoderadoValido) {
        this.guardarApoderado(this.formApoderado, false);
      }
      if (this.idTipoPersonaSeleccionadoDemandada) {
        if (this.idTipoPersonaSeleccionadoDemandada == 1) {
          if (this.formDemandadaNatural != undefined) {
            this.guardarDemandado(this.formDemandadaNatural, 1, false);
          }
        } else {
          if (this.formDemandadaJuridico != undefined) {
            this.guardarDemandado(this.formDemandadaJuridico, 2, false);
          }
        }
      }
      let tramite = this.buildFormTramite(false);
      // antiguo funcional
      const response = await firstValueFrom(
        this.serviceMercantiles.crearTramiteSSM(tramite)
      );
      if (response.success) {
        this.idTramite = response.data?.Id!;
        this.idTramiteAsuntosMercantiles = response.data?.Id!;
        this.enviarDocumentos = true;
        this.cd.detectChanges(); // fuerza el render del hijo

        const mensaje = this.alertaText['asuntos-alertas']['tramite-guardado-mensaje'].replace('{{proceso}}', this.entidad);
        await this.alertaModalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          mensaje
        );

        return { success: true };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false };
    }
  }

  // construccion body para servicio
  buildFormTramite(esEnviar: boolean): TramiteSuperintendeciaMercantilDto {
    let idAsunto: number | null = null;
    if (this.idAsunto != null) {
      idAsunto = this.idAsunto;
    } else {
      idAsunto = this.formTipoAsunto.get('asunto')?.value;
    }
    let tramite: TramiteSuperintendeciaMercantilDto = {
      id: this.idTramite,
      idCreador: this.dataUsuario.idUsuario,
      enviar: esEnviar,
      idTipoTramite: this.tipoTramite,
      tieneApoderado: this.apoderados.length > 0,
      asunto: {
        id: idAsunto,
        valor: this.getAsunto(this.formTipoAsunto.get('asunto')?.value),
      },
      demandante: this.obtenerPrimerNombreByArray(this.demandantes),
      multiplesApoderados: this.obtenerPrimerNombreByArray(this.apoderados),
      demandado: this.obtenerPrimerNombreByArray(this.demandados),
      enviarCorreoDemandado: this.enviarCorreoDemandado ?? false,
      idioma: this.idiomaActual
    };
    if (tramite?.demandante?.length == 0) {
      if (this.idTipoPersonaSeleccionadoDemandante) {
        const tipoPersona = +this.idTipoPersonaSeleccionadoDemandante;
        const esPersonaNatural = tipoPersona == Constants.TIPO_PERSONA.NATURAL;
        const form = esPersonaNatural ? this.formDemandanteNatural : this.formDemandanteJuridico;
        // se envia false por que ya ejecuta el guardado provisional desde que se da en guardar sin enviar
        this.guardarDemandante(form, tipoPersona, false);
        tramite = {
          ...tramite,
          demandante: this.obtenerPrimerNombreByArray(this.demandantes)
        }
      }
    } else {
      if (this.idTipoPersonaSeleccionadoDemandante) {
        const tipoPersona = +this.idTipoPersonaSeleccionadoDemandante;
        const esPersonaNatural = tipoPersona == Constants.TIPO_PERSONA.NATURAL;
        const form = esPersonaNatural ? this.formDemandanteNatural : this.formDemandanteJuridico;
        // se envia false por que ya ejecuta el guardado provisional desde que se da en guardar sin enviar
        this.guardarDemandante(form, tipoPersona, false);
        tramite = {
          ...tramite,
          demandante: this.obtenerPrimerNombreByArray(this.demandantes)
        }
      }
    }
    if (tramite?.multiplesApoderados?.length == 0) {
      if (this.mostrarApoderado && this.formApoderado) {
        // se envia false por que ya ejecuta el guardado provisional desde que se da en guardar sin enviar
        this.guardarApoderado(this.formApoderado, false);
        tramite = {
          ...tramite,
          multiplesApoderados: this.obtenerPrimerNombreByArray(this.apoderados)
        }
      }
    } else {
      if (this.mostrarApoderado && this.formApoderado) {
        // se envia false por que ya ejecuta el guardado provisional desde que se da en guardar sin enviar
        this.guardarApoderado(this.formApoderado, false);
        tramite = {
          ...tramite,
          multiplesApoderados: this.obtenerPrimerNombreByArray(this.apoderados)
        }
      }
    }
    if (tramite?.demandado?.length == 0) {
      if (this.idTipoPersonaSeleccionadoDemandada) {
        const tipoPersona = +this.idTipoPersonaSeleccionadoDemandada;
        const esPersonaNatural = tipoPersona == Constants.TIPO_PERSONA.NATURAL;
        const form = esPersonaNatural ? this.formDemandadaNatural : this.formDemandadaJuridico;
        this.guardarDemandado(form, tipoPersona, false);
        tramite = {
          ...tramite,
          demandante: this.obtenerPrimerNombreByArray(this.demandantes)
        }
      }
    } else {
      if (this.idTipoPersonaSeleccionadoDemandada) {
        const tipoPersona = +this.idTipoPersonaSeleccionadoDemandada;
        const esPersonaNatural = tipoPersona == Constants.TIPO_PERSONA.NATURAL;
        const form = esPersonaNatural ? this.formDemandadaNatural : this.formDemandadaJuridico;
        this.guardarDemandado(form, tipoPersona, false);
        tramite = {
          ...tramite,
          demandante: this.obtenerPrimerNombreByArray(this.demandantes)
        }
      }
    }

    return tramite;
  }

  // Get data usuario logeado

  getData() {
    this.dataUsuario = this.textTransformService.transformarAMayusculas(
      this.dataUsuario
    );
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    if (user_type.Nombre === 'Abogado') {
      this.getDataUsuario(this.dataUsuario.idPersona!);
    } else {
      /**
       * Setea inmediatamente el valor de tipoPersonaDemandante
       * para que muestre el formulario Datos del demandante
       */
      const tipoPersona: PersonaNaturalDTO = {
        tipoPersonaDemandante: this.dataUsuario.tipoPersona!,
        country: 0,
        departament: 0,
        municipality: 0,
      };
      this.tipoPersonaDemandante = this.tipoPersonaDemandante.map(field => {
        if (tipoPersona[field.name as keyof typeof tipoPersona] !== undefined) {
          field.value = tipoPersona[field.name as keyof typeof tipoPersona];
        }
        return field;
      });

      if (this.dataUsuario.tipoPersona == Constants.TIPO_PERSONA.NATURAL) {
        this.mostrarTipoPersonaDemandante = true;
        this.mostrarApoderado = false;
        this.idTipoPersonaSeleccionadoDemandante =
          Constants.TIPO_PERSONA.NATURAL;
        this.mostrarFomularioNaturalDemandante = true;
        this.mostrarFomularioJuridicoDemandante = false;
        const personaNatural: PersonaNaturalDTO = {
          typeOfDocument: this.getIdDocumento(
            String(this.dataUsuario.tipoDocumento)
          ),
          numberOfDocument: +this.dataUsuario.identificacion!,
          primerNombre: this.dataUsuario.primerNombre,
          segundoNombre: this.dataUsuario.segundoNombre,
          primerApellido: this.dataUsuario.primerApellido,
          segundoApellido: this.dataUsuario.segundoApellido,
          email: this.dataUsuario.correoElectronico,
          country: this.dataUsuario.pais,
          departament: this.dataUsuario.departamento,
          municipality: this.dataUsuario.municipio,
          otroDepartamentoDemandantePN: this.dataUsuario.otroDepartamento,
          otroMunicipioDemandantePN: this.dataUsuario.otroMunicipio,
          direccionPersona:
            this.dataUsuario.direccion?.find(
              (elemento: {
                Direccion_Notificacion?: string;
                Es_Primaria?: boolean;
                Id?: number;
              }) => elemento.Es_Primaria
            )?.Direccion_Notificacion ??
            this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ??
            '',
        };
        setTimeout(() => {
          this.demandantePN = this.demandantePN.map(field => {
            if (
              personaNatural[field.name as keyof typeof personaNatural] !==
              undefined
            ) {
              field.value =
                personaNatural[field.name as keyof typeof personaNatural];
            }
            return field;
          });
          this.demandantePN.forEach(field => {
            if (field.name == 'country') {
              if (field.value != 1) {
                this.setValidatorUbicacion(this.demandantePN, 1)
              }
            }
          });
        }, 800);
      } else {
        this.mostrarTipoPersonaDemandante = true;
        this.idTipoPersonaSeleccionadoDemandante =
          Constants.TIPO_PERSONA.JURIDICA;
        this.mostrarFomularioNaturalDemandante = false;
        this.mostrarFomularioJuridicoDemandante = true;
        const personaJuridica: PersonaJuridicaDTO = {
          typeOfDocument: this.getIdDocumento(
            String(this.dataUsuario.tipoDocumento)
          ),
          numberOfDocument: +this.dataUsuario.identificacion!,
          razonSocial: this.dataUsuario.razonSocial,
          country: this.dataUsuario.pais,
          departament: this.dataUsuario.departamento,
          municipality: this.dataUsuario.municipio,
          otroDepartamentoDemandantePJ: this.dataUsuario.otroDepartamento,
          otroMunicipioDemandantePJ: this.dataUsuario.otroMunicipio,
          addressNotificationJudicial:
            this.dataUsuario.direccion?.find(
              (elemento: {
                Direccion_Notificacion?: string;
                Es_Primaria?: boolean;
                Id?: number;
              }) => elemento.Es_Primaria
            )?.Direccion_Notificacion ??
            this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ??
            '',
          email: this.dataUsuario.correoElectronico,
        };
        setTimeout(() => {
          this.demandantePJ = this.demandantePJ.map(field => {
            if (
              personaJuridica[field.name as keyof typeof personaJuridica] !==
              undefined
            ) {
              field.value =
                personaJuridica[field.name as keyof typeof personaJuridica];
            }
            return field;
          });
          this.demandantePN.forEach(field => {
            if (field.name == 'country') {
              if (field.value != 1) {
                this.setValidatorUbicacion(this.demandantePJ, 2)
              }
            }
          });
        }, 800);
      }
    }
  }

  getDataUsuario(idPersona: number) {
    let tarjeta: number = 0;
    this.datosProvisionalesService
      .getDataAbogado(idPersona)
      .subscribe((response: any) => {
        this.mostrarTipoPersonaDemandante = false;
        this.mostrarApoderado = true;
        tarjeta = response.datoAdicionalAbogado.Tarjeta_Profesional;
        setTimeout(() => {
          this.apoderado = this.apoderado.map(field => {
            switch (field.name) {
              case 'primerNombre':
                field.value = this.dataUsuario.primerNombre;
                break;
              case 'segundoNombre':
                field.value = this.dataUsuario.segundoNombre;
                break;
              case 'primerApellido':
                field.value = this.dataUsuario.primerApellido;
                break;
              case 'segundoApellido':
                field.value = this.dataUsuario.segundoApellido;
                break;
              case 'typeOfDocument':
                field.value = this.getIdDocumento(
                  String(this.dataUsuario.tipoDocumento)
                );
                break;
              case 'numberOfDocument':
                field.value = this.dataUsuario.identificacion;
                break;
              case 'tarjetaProfesional':
                field.value = tarjeta;
                break;
              case 'email':
                field.value = this.dataUsuario.correoElectronico;
                break;
              case 'telefono':
                field.value = this.dataUsuario.telefonoPrincipal;
                break;
              case 'country':
                field.value = this.dataUsuario.pais;
                break;
              case 'departament':
                field.value = this.dataUsuario.departamento;
                break;
              case 'municipality':
                field.value = this.dataUsuario.municipio;
                break;
              case 'otroDepartamentoApoderado':
                field.value = this.dataUsuario.otroDepartamento ?? '';
                field.required = this.dataUsuario.pais != 1;
                break;
              case 'otroMunicipioApoderado':
                field.value = this.dataUsuario.otroMunicipio ?? '';
                field.required = this.dataUsuario.pais != 1;
                break;
              case 'addressNotificationJudicial':
                field.value =
                  this.dataUsuario?.direccion?.find(
                    (elemento: {
                      Direccion_Notificacion?: string;
                      Es_Primaria?: boolean;
                      Id?: number;
                    }) => elemento.Es_Primaria
                  )?.Direccion_Notificacion ??
                  this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ??
                  '';
                break;
            }
            return field;
          });
          if (this.dataUsuario.pais != 1) {
            this.auxIdCountryApoderado.push(
              this.formApoderado.get('country')?.value
            )
            this.formApoderado.get('otroDepartamentoApoderado')?.addValidators([Validators.required,
            Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
            Validators.maxLength(30)]);
            this.formApoderado.get('otroDepartamentoApoderado')?.updateValueAndValidity();
            this.formApoderado.get('otroMunicipioApoderado')?.addValidators([Validators.required,
            Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
            Validators.maxLength(30)]);
            this.formApoderado.get('otroMunicipioApoderado')?.updateValueAndValidity();

          }
        }, 800);
      });
  }

  setearUbicacionApoderado(idPais: number) {
    if (idPais == 1) {
      this.apoderado.forEach(field => {
        switch (field.name) {
          case 'departament':
            field.value = this.dataUsuario.departamento;
            break;
          case 'municipality':
            field.value = this.dataUsuario.municipio;
            break;
        }
        // return field
      });
    } else {
      this.apoderado.forEach(field => {
        switch (field.name) {
          case 'otroDepartamentoApoderado':
            field.value = this.dataUsuario.otroDepartamento ?? '';
            break;
          case 'otroMunicipioApoderado':
            field.value = this.dataUsuario.otroMunicipio ?? '';
            break;
        }
        // return field;
      });
    }
  }

  getDataUser(idUsuario: number) {
    this._cuentaService
      .getDataPersonal(idUsuario)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.dataUsuario.otroDepartamento = response.data.Otro_Departamento;
          this.dataUsuario.otroMunicipio = response.data.Otro_Municipio;
        }
      });
  }

  setValidatorUbicacion(form: FormField[], typePerson: number) {
    this.auxIdCountryDemandante.push(
      this.formDemandanteNatural.get('country')?.value
    )
    if (typePerson == Constants.TIPO_PERSONA.NATURAL) {
      form.forEach(field => {
        if (['otroDepartamentoDemandantePN', 'otroMunicipioDemandantePN'].includes(field.name)) {
          field.required = true;
        }
      });
      this.formDemandanteNatural.get('otroDepartamentoDemandantePN')?.addValidators([Validators.required,
      Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
      Validators.maxLength(30)]);
      this.formDemandanteNatural.get('otroDepartamentoDemandantePN')?.updateValueAndValidity();
      this.formDemandanteNatural.get('otroMunicipioDemandantePN')?.addValidators([Validators.required,
      Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
      Validators.maxLength(30)]);
      this.formDemandanteNatural.get('otroMunicipioDemandantePN')?.updateValueAndValidity();
    } else {
      form.forEach(field => {
        if (['otroDepartamentoDemandantePJ', 'otroMunicipioDemandantePJ'].includes(field.name)) {
          field.required = true;
        }
      });
      this.formDemandanteJuridico.get('otroDepartamentoDemandantePJ')?.addValidators([Validators.required,
      Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
      Validators.maxLength(30)]);
      this.formDemandanteJuridico.get('otroDepartamentoDemandantePJ')?.updateValueAndValidity();
      this.formDemandanteJuridico.get('otroMunicipioDemandantePJ')?.addValidators([Validators.required,
      Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
      Validators.maxLength(30)]);
      this.formDemandanteJuridico.get('otroMunicipioDemandantePJ')?.updateValueAndValidity();
    }

  }

  // Obtiene el asunto por id
  getAsunto(idAsunto: number): string {
    const nombre = this.listaTipoAsunto.find(
      (elemento: ListaValorResponseDto) => idAsunto === elemento.Id
    );
    return nombre?.Valor!;
  }

  // obtiene el id del tipo de documento por nombre
  getIdDocumento(tipoDocumento: string): number {
    if (typeof tipoDocumento == 'string') {
      const documento = this.listaTiposDocumento.find(
        (elemento: any) => elemento.TipoDocumento === tipoDocumento
      );
      return +documento?.Id!;
    } else {
      return tipoDocumento[0];
    }
  }

  getMetodos() {
    this.getListaGeneros();
    this.getListaSociedades();
    this.getCountries();
  }

  cancelarAgregar() {
    this.mostrarApoderado = false;
    this.mostrarTipoPersonaDemandante = false;
    this.mostrarFomularioNaturalDemandante = false;
    this.mostrarFomularioJuridicoDemandante = false;
    this.mostrarTipoPersonaDemandada = false;
    this.mostrarFomularioJuridicoDemandada = false;
    this.mostrarFomularioNaturalDemandada = false;
    if (this.formApoderado) {
      this.formApoderado.reset();
    }
    if (this.formDemandadaNatural) {
      this.formDemandadaNatural.reset();
    }
    if (this.formDemandadaJuridico) {
      this.formDemandadaJuridico.reset();
    }
    if (this.formDemandanteNatural) {
      this.formDemandanteNatural.reset();
    }
    if (this.formDemandanteJuridico) {
      this.formDemandanteJuridico.reset();
    }
  }

  mostrarCamposRequeridos(formGroup: FormGroup) {
    if (formGroup) {
      const camposRequeridos = Object.keys(formGroup.controls).filter(
        controlName =>
          formGroup.get(controlName)?.hasValidator(Validators.required)
      );
    }
  }

  correoDemandado(demandado: any): string {
    return demandado?.correoElectronico ?? '';
  }

  nombreDemandado(demandado: any): string {
    return `${demandado.primerNombre ?? ''} `.trim();
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }
  get resumenCopiaEnvio(): { correo: string; nombre: string } {
    const correos = this.demandados
      .map(d => this.correoDemandado(d))
      .filter(correo => correo)
      .join(', ');

    const nombres = this.demandados
      .map(d => this.nombreDemandado(d))
      .filter(nombre => nombre)
      .join(', ');

    return { correo: correos, nombre: nombres };
  }
  validarActoresCompletos(): boolean {
    const demandantesCompletos =
      this.demandantes.length > 0 &&
      this.demandantes.every((d) => this.esDemandanteValido(d));

    const demandadosCompletos =
      this.demandados.length > 0 &&
      this.demandados.every((d) => this.esDemandadoValido(d));

    const apoderadosCompletos =
      this.apoderados.length > 0 &&
      this.apoderados.every((a) => this.esApoderadoValido(a));

    return demandantesCompletos && demandadosCompletos && apoderadosCompletos;
  }

  private validarIdentificacion(p: PersonaDto): boolean {
    if (!p.idTipoIdentificacion) {
      return false;
    }

    if (!p.identificacion) {
      return false;
    }

    const pattern = this.getPatternIdentificacion(p.idTipoIdentificacion);

    if (!pattern.test(p.identificacion)) {
      return false;
    }

    return true;
  }


  private validarDireccion(p: PersonaDto): boolean {
    const direccion = p.direccionPersona?.[0]?.direccionNotificacion;


    if (!direccion) {
      return false;
    }

    if (direccion.length < 10 || direccion.length > 40) {
      return false;
    }

    const regex = new RegExp(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS);

    if (!regex.test(direccion)) {
      return false;
    }

    return true;
  }

  private validarUbicacion(
    p: PersonaDto,
    rol: "PN" | "PJ" | "APODERADO" | "RL" | "DEMANDADO_PN" | "DEMANDADO_PJ"
  ): boolean {

    // --------------------------------------------
    // 1. Validar país según rol
    // --------------------------------------------
    const country = rol === "RL" ? p.countryRl : p.country;

    if (!country) {
      console.log(`[Ubicación] Rol ${rol} no tiene country definido.`);
      return false;
    }

    const esExtranjero = country !== Constants.ID_COLOMBIA;

    // --------------------------------------------
    // 2. Validación Colombia
    // --------------------------------------------
    if (!esExtranjero) {
      const ok = !!p.municipio?.id && !!p.municipio?.idDepartamento;

      if (!ok) {
        console.log(`[Ubicación] Rol ${rol}: municipio/idDepartamento faltantes en Colombia`);
        return false;
      }

      return true; // Todo bien para Colombia
    }

    // --------------------------------------------
    // 3. Validación Extranjero — invocar getters según el rol
    // --------------------------------------------
    let departamento: string | undefined;
    let municipio: string | undefined;

    switch (rol) {
      case "PN":
        departamento = this.obtenerDepartamentoDemandantePN(p);
        municipio = this.obtenerMunicipioDemandantePN(p);
        break;

      case "PJ":
        departamento = this.obtenerDepartamentoDemandantePJ(p);
        municipio = this.obtenerMunicipioDemandantePJ(p);
        break;

      case "APODERADO":
        departamento = this.obtenerDepartamentoApoderado(p);
        municipio = this.obtenerMunicipioApoderado(p);
        break;

      case "DEMANDADO_PN":
        departamento = this.obtenerDepartamentoDemandadoPN(p);
        municipio = this.obtenerMunicipioDemandadoPN(p);
        break;

      case "DEMANDADO_PJ":
        departamento = this.obtenerDepartamentoDemandadoPJ(p);
        municipio = this.obtenerMunicipioDemandadoPJ(p);
        break;

      case "RL":
        departamento = this.obtenerDepartamentoRL(p);
        municipio = this.obtenerMunicipioRL(p);
        break;
    }

    const valido = !!departamento && !!municipio;

    if (!valido) {
      console.log(`[Ubicación] Rol ${rol}: datos extranjeros incompletos`, { departamento, municipio, p });
    }

    return valido;
  }

  private validarNombres(p: PersonaDto): boolean {

    const re = new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT);

    if (!p.primerNombre) {
      return false;
    }

    if (p.segundoNombre && !re.test(p.segundoNombre)) {
      return false;
    }

    if (!p.primerApellido || !re.test(p.primerApellido)) {
      return false;
    }

    if (p.segundoApellido && !re.test(p.segundoApellido)) {
      return false;
    }

    return true;
  }

  private validarEmpresa(p: PersonaDto): boolean {

    const re = new RegExp(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL);

    if (!p.razonSocial || !re.test(p.razonSocial)) {
      return false;
    }

    return true;
  }

  private validarRepresentanteLegal(rl: PersonaDto): boolean {

    if (!rl) {
      return false;
    }

    if (!this.validarIdentificacion(rl)) return false;
    if (!this.validarNombres(rl)) return false;

    if (!this.validarUbicacion(rl, "RL")) return false;
    if (!this.validarDireccion(rl)) return false;

    // Teléfono RL
    if (
      !rl.telefonoPrincipal ||
      !new RegExp(Constants.REGEX_TELEFONO).test(rl.telefonoPrincipal)
    ) {
      return false;
    }

    // Correo RL
    if (
      !rl.correoElectronico ||
      !new RegExp(Constants.REGEX_CORREO_ELECTRONICO).test(rl.correoElectronico)
    ) {
      return false;
    }

    return true;
  }


  private esDemandanteValido(p: PersonaDto): boolean {
    if (!p) return false;

    const esNatural = p.idTipoPersona === Constants.TIPO_PERSONA.NATURAL;

    if (!p.telefonoPrincipal || !new RegExp(Constants.REGEX_TELEFONO).test(p.telefonoPrincipal)) return false;
    if (!p.correoElectronico || !new RegExp(Constants.REGEX_CORREO_ELECTRONICO).test(p.correoElectronico)) return false;
    if (!this.validarDireccion(p)) return false;

    if (esNatural) {
      return this.validarIdentificacion(p)
        && this.validarUbicacion(p, "PN")
        && this.validarNombres(p)
        && !!p.idSexo
        && !!p.nacionalidad;
    }

    // PJ
    return this.validarIdentificacion(p)
      && this.validarUbicacion(p, "PJ")
      && this.validarEmpresa(p)
      && this.validarRepresentanteLegal(p.datosRepresentanteLegal!);
  }

  private esDemandadoValido(p: PersonaDto): boolean {
    if (!p) return false;

    const esNatural = p.idTipoPersona === Constants.TIPO_PERSONA.NATURAL;

    if (!this.validarDireccion(p)) return false;

    if (esNatural) {
      return this.validarIdentificacion(p)
        && this.validarUbicacion(p, "DEMANDADO_PN")
        && this.validarNombres(p)
        && (!p.correoElectronico || new RegExp(Constants.REGEX_CORREO_ELECTRONICO).test(p.correoElectronico));
    }

    // PJ
    return this.validarIdentificacion(p)
      && this.validarUbicacion(p, "DEMANDADO_PJ")
      && this.validarEmpresa(p)
      && !!p.correoElectronico
      && new RegExp(Constants.REGEX_CORREO_ELECTRONICO).test(p.correoElectronico);
  }


  private esApoderadoValido(p: PersonaDto): boolean {
    if (!p) return false;

    return this.validarIdentificacion(p)
      && this.validarUbicacion(p, "APODERADO")
      && this.validarDireccion(p)
      && this.validarNombres(p)
      && !!p.correoElectronico
      && new RegExp(Constants.REGEX_CORREO_ELECTRONICO).test(p.correoElectronico)
      && !!p.tarjetaProfesional
      && new RegExp(Constants.REGEX_TELEFONO).test(p.tarjetaProfesional);
  }

  getPatternIdentificacion(tipoDocumentoId: number): RegExp {
    switch (tipoDocumentoId) {
      case 1:
      case 2:
      case 5:
        return /^\d{4,12}$/;
      case 4:
        return /^[a-zA-Z0-9]{4,8}$/;
      case 3:
        return /^\d+$/;
      default:
        return /.*/;
    }
  }

  private obtenerDepartamentoGenerico(
    persona: PersonaDto,
    campoOtro: keyof PersonaDto
  ): string | undefined {
    const valorOtro = persona[campoOtro];

    if (typeof valorOtro === 'string' && valorOtro.trim() !== '') {

      return valorOtro.trim();
    }

    return persona.departamentoExtranjero || undefined;
  }

  private obtenerMunicipioGenerico(
    persona: PersonaDto,
    campoOtro: keyof PersonaDto
  ): string | undefined {
    const valorOtro = persona[campoOtro];

    if (typeof valorOtro === 'string' && valorOtro.trim() !== '') {
      return valorOtro.trim();
    }

    return persona.ciudadExtranjero || undefined;
  }

  // demandante pn
  private obtenerDepartamentoDemandantePN(p: PersonaDto) {
    return this.obtenerDepartamentoGenerico(p, 'otroDepartamentoDemandantePN');
  }

  private obtenerMunicipioDemandantePN(p: PersonaDto) {
    return this.obtenerMunicipioGenerico(p, 'otroMunicipioDemandantePN');
  }
  // demandante pj
  private obtenerDepartamentoDemandantePJ(p: PersonaDto) {
    return this.obtenerDepartamentoGenerico(p, 'otroDepartamentoDemandantePJ');
  }

  private obtenerMunicipioDemandantePJ(p: PersonaDto) {
    return this.obtenerMunicipioGenerico(p, 'otroMunicipioDemandantePJ');
  }

  // RL
  private obtenerDepartamentoRL(p: PersonaDto) {
    return this.obtenerDepartamentoGenerico(p, 'otroDepartamentoRL');
  }

  private obtenerMunicipioRL(p: PersonaDto) {
    return this.obtenerMunicipioGenerico(p, 'otroMunicipioRL');
  }

  // apoderado
  private obtenerDepartamentoApoderado(p: PersonaDto) {
    return this.obtenerDepartamentoGenerico(p, 'otroDepartamentoApoderado');
  }

  private obtenerMunicipioApoderado(p: PersonaDto) {
    return this.obtenerMunicipioGenerico(p, 'otroMunicipioApoderado');
  }

  // demandando pn
  private obtenerDepartamentoDemandadoPN(p: PersonaDto) {
    return this.obtenerDepartamentoGenerico(p, 'otroDepartamentoDemandadoPN');
  }

  private obtenerMunicipioDemandadoPN(p: PersonaDto) {
    return this.obtenerMunicipioGenerico(p, 'otroMunicipioDemandadoPN');
  }

  // demandado pj
  private obtenerDepartamentoDemandadoPJ(p: PersonaDto) {
    return this.obtenerDepartamentoGenerico(p, 'otroDepartamentoDemandadoPJ');
  }

  private obtenerMunicipioDemandadoPJ(p: PersonaDto) {
    return this.obtenerMunicipioGenerico(p, 'otroMunicipioDemandadoPJ');
  }

  markFormsAsTouched() {

    // Marcar todos los <app-form>
    if (this.personaComponentes && this.personaComponentes.length > 0) {
      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });
    }
  }
}
